import { $ as e, $t as t, A as n, At as r, B as i, Bt as a, C as o, Ct as s, D as c, Dt as l, E as u, Et as d, F as f, Ft as p, G as m, Gt as h, H as g, Ht as _, I as v, It as y, J as b, Jt as ee, K as te, Kt as ne, L as x, Lt as S, M as re, Mt as ie, N as ae, Nt as oe, O as se, Ot as ce, P as le, Pt as ue, Q as de, Qt as fe, R as pe, Rt as me, S as he, St as ge, T as _e, Tt as ve, U as ye, Ut as be, V as xe, Vt as Se, W as Ce, Wt as we, X as Te, Xt as Ee, Y as De, Yt as Oe, Z as ke, Zt as Ae, _ as je, _t as Me, a as Ne, at as Pe, b as Fe, bt as Ie, c as Le, ct as Re, d as ze, dt as Be, et as Ve, f as He, ft as Ue, g as We, gt as Ge, h as Ke, ht as qe, i as Je, it as Ye, j as Xe, jt as Ze, k as Qe, kt as $e, l as et, lt as tt, m as nt, mt as rt, n as it, nn as at, nt as ot, o as st, ot as ct, p as lt, pt as ut, q as dt, qt as ft, r as pt, rt as mt, s as ht, st as gt, t as _t, tn as vt, tt as yt, u as bt, ut as xt, v as St, vt as Ct, w as wt, wt as Tt, x as Et, xt as Dt, y as Ot, yt as kt, z as At, zt as jt } from "./sdk.gen-DvYHZRAO.js";
import { $ as Mt, A as Nt, B as Pt, C as Ft, Ct as It, D as Lt, E as Rt, F as zt, G as Bt, H as Vt, I as Ht, J as Ut, K as Wt, L as Gt, M as Kt, N as qt, O as Jt, P as Yt, Q as Xt, R as Zt, S as Qt, St as $t, T as en, U as tn, V as nn, W as rn, X as an, Y as on, Z as sn, _ as cn, _t as ln, a as un, at as dn, b as fn, bt as pn, c as mn, ct as hn, d as gn, dt as _n, et as vn, f as yn, ft as bn, g as xn, gt as Sn, h as Cn, ht as wn, i as Tn, it as En, j as Dn, k as On, l as kn, lt as An, m as jn, mt as Mn, n as Nn, nt as Pn, ot as Fn, p as In, pt as Ln, q as Rn, r as zn, rt as Bn, st as Vn, t as Hn, tt as Un, u as C, ut as Wn, v as Gn, vt as Kn, w as qn, wt as Jn, x as Yn, xt as Xn, y as Zn, yt as Qn, z as $n } from "./shippablePackages-Cf3JSF1b.js";
import { t as er } from "./useOrderService-1KM6veEh.js";
//#region \0rolldown/runtime.js
var tr = Object.defineProperty, nr = /* @__PURE__ */ ((e, t) => {
	let n = {};
	for (var r in e) tr(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || tr(n, Symbol.toStringTag, { value: "Module" }), n;
})({});
//#endregion
//#region ../../node_modules/.pnpm/@vue+shared@3.5.41/node_modules/@vue/shared/dist/shared.esm-bundler.js
// @__NO_SIDE_EFFECTS__
function rr(e) {
	let t = /* @__PURE__ */ Object.create(null);
	for (let n of e.split(",")) t[n] = 1;
	return (e) => e in t;
}
var ir = process.env.NODE_ENV === "production" ? {} : Object.freeze({});
process.env.NODE_ENV === "production" || Object.freeze([]);
var ar = () => {}, or = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), sr = (e) => e.startsWith("onUpdate:"), cr = Object.assign, lr = Object.prototype.hasOwnProperty, ur = (e, t) => lr.call(e, t), w = Array.isArray, dr = (e) => vr(e) === "[object Map]", fr = (e) => vr(e) === "[object Set]", T = (e) => typeof e == "function", pr = (e) => typeof e == "string", mr = (e) => typeof e == "symbol", hr = (e) => typeof e == "object" && !!e, gr = (e) => (hr(e) || T(e)) && T(e.then) && T(e.catch), _r = Object.prototype.toString, vr = (e) => _r.call(e), yr = (e) => vr(e).slice(8, -1), br = (e) => vr(e) === "[object Object]", xr = (e) => pr(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Sr = ((e) => {
	let t = /* @__PURE__ */ Object.create(null);
	return ((n) => t[n] || (t[n] = e(n)));
})((e) => e.charAt(0).toUpperCase() + e.slice(1)), Cr = (e, t) => !Object.is(e, t), wr = (e, t, n, r = !1) => {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		writable: r,
		value: n
	});
}, Tr, Er = () => Tr ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
function Dr(e) {
	if (w(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = pr(r) ? jr(r) : Dr(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	}
	if (pr(e) || hr(e)) return e;
}
var Or = /;(?![^(]*\))/g, kr = /:([^]+)/, Ar = /\/\*[^]*?\*\//g;
function jr(e) {
	let t = {};
	return e.replace(Ar, "").split(Or).forEach((e) => {
		if (e) {
			let n = e.split(kr);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function Mr(e) {
	let t = "";
	if (pr(e)) t = e;
	else if (w(e)) for (let n = 0; n < e.length; n++) {
		let r = Mr(e[n]);
		r && (t += r + " ");
	}
	else if (hr(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+reactivity@3.5.41/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function Nr(e, ...t) {
	console.warn(`[Vue warn] ${e}`, ...t);
}
var E, Pr = /* @__PURE__ */ new WeakSet(), Fr = class {
	constructor(e) {
		this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0;
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		this.flags & 64 && (this.flags &= -65, Pr.has(this) && (Pr.delete(this), this.trigger()));
	}
	notify() {
		this.flags & 2 && !(this.flags & 32) || this.flags & 8 || zr(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2, Qr(this), Hr(this);
		let e = E, t = Jr;
		E = this, Jr = !0;
		try {
			return this.fn();
		} finally {
			process.env.NODE_ENV !== "production" && E !== this && Nr("Active effect was not restored correctly - this is likely a Vue internal bug."), Ur(this), E = e, Jr = t, this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let e = this.deps; e; e = e.nextDep) Kr(e);
			this.deps = this.depsTail = void 0, Qr(this), this.onStop && this.onStop(), this.flags &= -2;
		}
	}
	trigger() {
		this.flags & 64 ? Pr.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
	}
	runIfDirty() {
		Wr(this) && this.run();
	}
	get dirty() {
		return Wr(this);
	}
}, Ir = 0, Lr, Rr;
function zr(e, t = !1) {
	if (e.flags |= 8, t) {
		e.next = Rr, Rr = e;
		return;
	}
	e.next = Lr, Lr = e;
}
function Br() {
	Ir++;
}
function Vr() {
	if (--Ir > 0) return;
	if (Rr) {
		let e = Rr;
		for (Rr = void 0; e;) {
			let t = e.next;
			e.next = void 0, e.flags &= -9, e = t;
		}
	}
	let e;
	for (; Lr;) {
		let t = Lr;
		for (Lr = void 0; t;) {
			let n = t.next;
			if (t.next = void 0, t.flags &= -9, t.flags & 1) try {
				t.trigger();
			} catch (t) {
				e ||= t;
			}
			t = n;
		}
	}
	if (e) throw e;
}
function Hr(e) {
	for (let t = e.deps; t; t = t.nextDep) t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Ur(e) {
	let t, n = e.depsTail, r = n;
	for (; r;) {
		let e = r.prevDep;
		r.version === -1 ? (r === n && (n = e), Kr(r), qr(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e;
	}
	e.deps = t, e.depsTail = n;
}
function Wr(e) {
	for (let t = e.deps; t; t = t.nextDep) if (t.dep.version !== t.version || t.dep.computed && (Gr(t.dep.computed) || t.dep.version !== t.version)) return !0;
	return !!e._dirty;
}
function Gr(e) {
	if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === $r) || (e.globalVersion = $r, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !Wr(e)))) return;
	e.flags |= 2;
	let t = e.dep, n = E, r = Jr;
	E = e, Jr = !0;
	try {
		Hr(e);
		let n = e.fn(e._value);
		(t.version === 0 || Cr(n, e._value)) && (e.flags |= 128, e._value = n, t.version++);
	} catch (e) {
		throw t.version++, e;
	} finally {
		E = n, Jr = r, Ur(e), e.flags &= -3;
	}
}
function Kr(e, t = !1) {
	let { dep: n, prevSub: r, nextSub: i } = e;
	if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = i), n.subs === e && (n.subs = r, !r && n.computed)) {
		n.computed.flags &= -5;
		for (let e = n.computed.deps; e; e = e.nextDep) Kr(e, !0);
	}
	!t && !--n.sc && n.map && n.map.delete(n.key);
}
function qr(e) {
	let { prevDep: t, nextDep: n } = e;
	t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
var Jr = !0, Yr = [];
function Xr() {
	Yr.push(Jr), Jr = !1;
}
function Zr() {
	let e = Yr.pop();
	Jr = e === void 0 || e;
}
function Qr(e) {
	let { cleanup: t } = e;
	if (e.cleanup = void 0, t) {
		let e = E;
		E = void 0;
		try {
			t();
		} finally {
			E = e;
		}
	}
}
var $r = 0, ei = class {
	constructor(e, t) {
		this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
}, ti = class {
	constructor(e) {
		this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
	}
	track(e) {
		if (!E || !Jr || E === this.computed) return;
		let t = this.activeLink;
		if (t === void 0 || t.sub !== E) t = this.activeLink = new ei(E, this), E.deps ? (t.prevDep = E.depsTail, E.depsTail.nextDep = t, E.depsTail = t) : E.deps = E.depsTail = t, ni(t);
		else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
			let e = t.nextDep;
			e.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e), t.prevDep = E.depsTail, t.nextDep = void 0, E.depsTail.nextDep = t, E.depsTail = t, E.deps === t && (E.deps = e);
		}
		return process.env.NODE_ENV !== "production" && E.onTrack && E.onTrack(cr({ effect: E }, e)), t;
	}
	trigger(e) {
		this.version++, $r++, this.notify(e);
	}
	notify(e) {
		Br();
		try {
			if (process.env.NODE_ENV !== "production") for (let t = this.subsHead; t; t = t.nextSub) t.sub.onTrigger && !(t.sub.flags & 8) && t.sub.onTrigger(cr({ effect: t.sub }, e));
			for (let e = this.subs; e; e = e.prevSub) e.sub.notify() && e.sub.dep.notify();
		} finally {
			Vr();
		}
	}
};
function ni(e) {
	if (e.dep.sc++, e.sub.flags & 4) {
		let t = e.dep.computed;
		if (t && !e.dep.subs) {
			t.flags |= 20;
			for (let e = t.deps; e; e = e.nextDep) ni(e);
		}
		let n = e.dep.subs;
		n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
	}
}
var ri = /* @__PURE__ */ new WeakMap(), ii = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Object iterate"), ai = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Map keys iterate"), oi = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Array iterate");
function si(e, t, n) {
	if (Jr && E) {
		let r = ri.get(e);
		r || ri.set(e, r = /* @__PURE__ */ new Map());
		let i = r.get(n);
		i || (r.set(n, i = new ti()), i.map = r, i.key = n), process.env.NODE_ENV === "production" ? i.track() : i.track({
			target: e,
			type: t,
			key: n
		});
	}
}
function ci(e, t, n, r, i, a) {
	let o = ri.get(e);
	if (!o) {
		$r++;
		return;
	}
	let s = (o) => {
		o && (process.env.NODE_ENV === "production" ? o.trigger() : o.trigger({
			target: e,
			type: t,
			key: n,
			newValue: r,
			oldValue: i,
			oldTarget: a
		}));
	};
	if (Br(), t === "clear") o.forEach(s);
	else {
		let i = w(e), a = i && xr(n);
		if (i && n === "length") {
			let e = Number(r);
			o.forEach((t, n) => {
				(n === "length" || n === oi || !mr(n) && n >= e) && s(t);
			});
		} else switch ((n !== void 0 || o.has(void 0)) && s(o.get(n)), a && s(o.get(oi)), t) {
			case "add":
				i ? a && s(o.get("length")) : (s(o.get(ii)), dr(e) && s(o.get(ai)));
				break;
			case "delete":
				i || (s(o.get(ii)), dr(e) && s(o.get(ai)));
				break;
			case "set": dr(e) && s(o.get(ii));
		}
	}
	Vr();
}
function li(e) {
	let t = /* @__PURE__ */ D(e);
	return t === e ? t : (si(t, "iterate", oi), /* @__PURE__ */ Yi(e) ? t : t.map(Qi));
}
function ui(e) {
	return si(e = /* @__PURE__ */ D(e), "iterate", oi), e;
}
function di(e, t) {
	return /* @__PURE__ */ Ji(e) ? $i(/* @__PURE__ */ qi(e) ? Qi(t) : t) : Qi(t);
}
var fi = {
	__proto__: null,
	[Symbol.iterator]() {
		return pi(this, Symbol.iterator, (e) => di(this, e));
	},
	concat(...e) {
		return li(this).concat(...e.map((e) => w(e) ? li(e) : e));
	},
	entries() {
		return pi(this, "entries", (e) => (e[1] = di(this, e[1]), e));
	},
	every(e, t) {
		return hi(this, "every", e, t, void 0, arguments);
	},
	filter(e, t) {
		return hi(this, "filter", e, t, (e) => e.map((e) => di(this, e)), arguments);
	},
	find(e, t) {
		return hi(this, "find", e, t, (e) => di(this, e), arguments);
	},
	findIndex(e, t) {
		return hi(this, "findIndex", e, t, void 0, arguments);
	},
	findLast(e, t) {
		return hi(this, "findLast", e, t, (e) => di(this, e), arguments);
	},
	findLastIndex(e, t) {
		return hi(this, "findLastIndex", e, t, void 0, arguments);
	},
	forEach(e, t) {
		return hi(this, "forEach", e, t, void 0, arguments);
	},
	includes(...e) {
		return _i(this, "includes", e);
	},
	indexOf(...e) {
		return _i(this, "indexOf", e);
	},
	join(e) {
		return li(this).join(e);
	},
	lastIndexOf(...e) {
		return _i(this, "lastIndexOf", e);
	},
	map(e, t) {
		return hi(this, "map", e, t, void 0, arguments);
	},
	pop() {
		return vi(this, "pop");
	},
	push(...e) {
		return vi(this, "push", e);
	},
	reduce(e, ...t) {
		return gi(this, "reduce", e, t);
	},
	reduceRight(e, ...t) {
		return gi(this, "reduceRight", e, t);
	},
	shift() {
		return vi(this, "shift");
	},
	some(e, t) {
		return hi(this, "some", e, t, void 0, arguments);
	},
	splice(...e) {
		return vi(this, "splice", e);
	},
	toReversed() {
		return li(this).toReversed();
	},
	toSorted(e) {
		return li(this).toSorted(e);
	},
	toSpliced(...e) {
		return li(this).toSpliced(...e);
	},
	unshift(...e) {
		return vi(this, "unshift", e);
	},
	values() {
		return pi(this, "values", (e) => di(this, e));
	}
};
function pi(e, t, n) {
	let r = ui(e), i = r[t]();
	return r !== e && !/* @__PURE__ */ Yi(e) && (i._next = i.next, i.next = () => {
		let e = i._next();
		return e.done || (e.value = n(e.value)), e;
	}), i;
}
var mi = Array.prototype;
function hi(e, t, n, r, i, a) {
	let o = ui(e), s = o !== e && !/* @__PURE__ */ Yi(e), c = o[t];
	if (c !== mi[t]) {
		let t = c.apply(e, a);
		return s ? Qi(t) : t;
	}
	let l = n;
	o !== e && (s ? l = function(t, r) {
		return n.call(this, di(e, t), r, e);
	} : n.length > 2 && (l = function(t, r) {
		return n.call(this, t, r, e);
	}));
	let u = c.call(o, l, r);
	return s && i ? i(u) : u;
}
function gi(e, t, n, r) {
	let i = ui(e), a = i !== e && !/* @__PURE__ */ Yi(e), o = n, s = !1;
	i !== e && (a ? (s = r.length === 0, o = function(t, r, i) {
		return s && (s = !1, t = di(e, t)), n.call(this, t, di(e, r), i, e);
	}) : n.length > 3 && (o = function(t, r, i) {
		return n.call(this, t, r, i, e);
	}));
	let c = i[t](o, ...r);
	return s ? di(e, c) : c;
}
function _i(e, t, n) {
	let r = /* @__PURE__ */ D(e);
	si(r, "iterate", oi);
	let i = r[t](...n);
	return (i === -1 || i === !1) && /* @__PURE__ */ Xi(n[0]) ? (n[0] = /* @__PURE__ */ D(n[0]), r[t](...n)) : i;
}
function vi(e, t, n = []) {
	Xr(), Br();
	let r = (/* @__PURE__ */ D(e))[t].apply(e, n);
	return Vr(), Zr(), r;
}
var yi = /* @__PURE__ */ rr("__proto__,__v_isRef,__isVue"), bi = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(mr));
function xi(e) {
	mr(e) || (e = String(e));
	let t = /* @__PURE__ */ D(this);
	return si(t, "has", e), t.hasOwnProperty(e);
}
var Si = class {
	constructor(e = !1, t = !1) {
		this._isReadonly = e, this._isShallow = t;
	}
	get(e, t, n) {
		if (t === "__v_skip") return e.__v_skip;
		let r = this._isReadonly, i = this._isShallow;
		if (t === "__v_isReactive") return !r;
		if (t === "__v_isReadonly") return r;
		if (t === "__v_isShallow") return i;
		if (t === "__v_raw") return n === (r ? i ? Vi : Bi : i ? zi : Ri).get(e) || Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
		let a = w(e);
		if (!r) {
			let e;
			if (a && (e = fi[t])) return e;
			if (t === "hasOwnProperty") return xi;
		}
		let o = Reflect.get(e, t, /* @__PURE__ */ ea(e) ? e : n);
		if ((mr(t) ? bi.has(t) : yi(t)) || (r || si(e, "get", t), i)) return o;
		if (/* @__PURE__ */ ea(o)) {
			let e = a && xr(t) ? o : o.value;
			return r && hr(e) ? /* @__PURE__ */ Wi(e) : e;
		}
		return hr(o) ? r ? /* @__PURE__ */ Wi(o) : /* @__PURE__ */ Ui(o) : o;
	}
}, Ci = class extends Si {
	constructor(e = !1) {
		super(!1, e);
	}
	set(e, t, n, r) {
		let i = e[t], a = w(e) && xr(t);
		if (!this._isShallow) {
			let r = /* @__PURE__ */ Ji(i);
			if (!/* @__PURE__ */ Yi(n) && !/* @__PURE__ */ Ji(n) && (i = /* @__PURE__ */ D(i), n = /* @__PURE__ */ D(n)), !a && /* @__PURE__ */ ea(i) && !/* @__PURE__ */ ea(n)) return r ? (process.env.NODE_ENV !== "production" && Nr(`Set operation on key "${String(t)}" failed: target is readonly.`, e[t]), !0) : (i.value = n, !0);
		}
		let o = a ? Number(t) < e.length : ur(e, t), s = Reflect.set(e, t, n, /* @__PURE__ */ ea(e) ? e : r);
		return e === /* @__PURE__ */ D(r) && s && (o ? Cr(n, i) && ci(e, "set", t, n, i) : ci(e, "add", t, n)), s;
	}
	deleteProperty(e, t) {
		let n = ur(e, t), r = e[t], i = Reflect.deleteProperty(e, t);
		return i && n && ci(e, "delete", t, void 0, r), i;
	}
	has(e, t) {
		let n = Reflect.has(e, t);
		return (!mr(t) || !bi.has(t)) && si(e, "has", t), n;
	}
	ownKeys(e) {
		return si(e, "iterate", w(e) ? "length" : ii), Reflect.ownKeys(e);
	}
}, wi = class extends Si {
	constructor(e = !1) {
		super(!0, e);
	}
	set(e, t) {
		return process.env.NODE_ENV !== "production" && Nr(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
	deleteProperty(e, t) {
		return process.env.NODE_ENV !== "production" && Nr(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
}, Ti = /* @__PURE__ */ new Ci(), Ei = /* @__PURE__ */ new wi(), Di = /* @__PURE__ */ new wi(!0), Oi = (e) => e, ki = (e) => Reflect.getPrototypeOf(e);
function Ai(e, t, n) {
	return function(...r) {
		let i = this.__v_raw, a = /* @__PURE__ */ D(i), o = dr(a), s = e === "entries" || e === Symbol.iterator && o, c = e === "keys" && o, l = i[e](...r), u = n ? Oi : t ? $i : Qi;
		return !t && si(a, "iterate", c ? ai : ii), cr(Object.create(l), { next() {
			let { value: e, done: t } = l.next();
			return t ? {
				value: e,
				done: t
			} : {
				value: s ? [u(e[0]), u(e[1])] : u(e),
				done: t
			};
		} });
	};
}
function ji(e) {
	return function(...t) {
		if (process.env.NODE_ENV !== "production") {
			let n = t[0] ? `on key "${t[0]}" ` : "";
			Nr(`${Sr(e)} operation ${n}failed: target is readonly.`, /* @__PURE__ */ D(this));
		}
		return e === "delete" ? !1 : e === "clear" ? void 0 : this;
	};
}
function Mi(e, t) {
	let n = {
		get(n) {
			let r = this.__v_raw, i = /* @__PURE__ */ D(r), a = /* @__PURE__ */ D(n);
			e || (Cr(n, a) && si(i, "get", n), si(i, "get", a));
			let { has: o } = ki(i), s = t ? Oi : e ? $i : Qi;
			if (o.call(i, n)) return s(r.get(n));
			if (o.call(i, a)) return s(r.get(a));
			r !== i && r.get(n);
		},
		get size() {
			let t = this.__v_raw;
			return !e && si(/* @__PURE__ */ D(t), "iterate", ii), t.size;
		},
		has(t) {
			let n = this.__v_raw, r = /* @__PURE__ */ D(n), i = /* @__PURE__ */ D(t);
			return e || (Cr(t, i) && si(r, "has", t), si(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
		},
		forEach(n, r) {
			let i = this, a = i.__v_raw, o = /* @__PURE__ */ D(a), s = t ? Oi : e ? $i : Qi;
			return !e && si(o, "iterate", ii), a.forEach((e, t) => n.call(r, s(e), s(t), i));
		}
	};
	return cr(n, e ? {
		add: ji("add"),
		set: ji("set"),
		delete: ji("delete"),
		clear: ji("clear")
	} : {
		add(e) {
			let n = /* @__PURE__ */ D(this), r = ki(n), i = /* @__PURE__ */ D(e), a = !t && !/* @__PURE__ */ Yi(e) && !/* @__PURE__ */ Ji(e) ? i : e;
			return r.has.call(n, a) || Cr(e, a) && r.has.call(n, e) || Cr(i, a) && r.has.call(n, i) || (n.add(a), ci(n, "add", a, a)), this;
		},
		set(e, n) {
			!t && !/* @__PURE__ */ Yi(n) && !/* @__PURE__ */ Ji(n) && (n = /* @__PURE__ */ D(n));
			let r = /* @__PURE__ */ D(this), { has: i, get: a } = ki(r), o = i.call(r, e);
			o ? process.env.NODE_ENV !== "production" && Li(r, i, e) : (e = /* @__PURE__ */ D(e), o = i.call(r, e));
			let s = a.call(r, e);
			return r.set(e, n), o ? Cr(n, s) && ci(r, "set", e, n, s) : ci(r, "add", e, n), this;
		},
		delete(e) {
			let t = /* @__PURE__ */ D(this), { has: n, get: r } = ki(t), i = n.call(t, e);
			i ? process.env.NODE_ENV !== "production" && Li(t, n, e) : (e = /* @__PURE__ */ D(e), i = n.call(t, e));
			let a = r ? r.call(t, e) : void 0, o = t.delete(e);
			return i && ci(t, "delete", e, void 0, a), o;
		},
		clear() {
			let e = /* @__PURE__ */ D(this), t = e.size !== 0, n = process.env.NODE_ENV === "production" ? void 0 : dr(e) ? new Map(e) : new Set(e), r = e.clear();
			return t && ci(e, "clear", void 0, void 0, n), r;
		}
	}), [
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((r) => {
		n[r] = Ai(r, e, t);
	}), n;
}
function Ni(e, t) {
	let n = Mi(e, t);
	return (t, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? t : Reflect.get(ur(n, r) && r in t ? n : t, r, i);
}
var Pi = { get: /* @__PURE__ */ Ni(!1, !1) }, Fi = { get: /* @__PURE__ */ Ni(!0, !1) }, Ii = { get: /* @__PURE__ */ Ni(!0, !0) };
function Li(e, t, n) {
	let r = /* @__PURE__ */ D(n);
	if (r !== n && t.call(e, r)) {
		let t = yr(e);
		Nr(`Reactive ${t} contains both the raw and reactive versions of the same object${t === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
	}
}
var Ri = /* @__PURE__ */ new WeakMap(), zi = /* @__PURE__ */ new WeakMap(), Bi = /* @__PURE__ */ new WeakMap(), Vi = /* @__PURE__ */ new WeakMap();
function Hi(e) {
	switch (e) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
// @__NO_SIDE_EFFECTS__
function Ui(e) {
	return /* @__PURE__ */ Ji(e) ? e : Ki(e, !1, Ti, Pi, Ri);
}
// @__NO_SIDE_EFFECTS__
function Wi(e) {
	return Ki(e, !0, Ei, Fi, Bi);
}
// @__NO_SIDE_EFFECTS__
function Gi(e) {
	return Ki(e, !0, Di, Ii, Vi);
}
function Ki(e, t, n, r, i) {
	if (!hr(e)) return process.env.NODE_ENV !== "production" && Nr(`value cannot be made ${t ? "readonly" : "reactive"}: ${String(e)}`), e;
	if (e.__v_raw && !(t && e.__v_isReactive) || e.__v_skip || !Object.isExtensible(e)) return e;
	let a = i.get(e);
	if (a) return a;
	let o = Hi(yr(e));
	if (o === 0) return e;
	let s = new Proxy(e, o === 2 ? r : n);
	return i.set(e, s), s;
}
// @__NO_SIDE_EFFECTS__
function qi(e) {
	return /* @__PURE__ */ Ji(e) ? /* @__PURE__ */ qi(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function Ji(e) {
	return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function Yi(e) {
	return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function Xi(e) {
	return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function D(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ D(t) : e;
}
function Zi(e) {
	return !ur(e, "__v_skip") && Object.isExtensible(e) && wr(e, "__v_skip", !0), e;
}
var Qi = (e) => hr(e) ? /* @__PURE__ */ Ui(e) : e, $i = (e) => hr(e) ? /* @__PURE__ */ Wi(e) : e;
// @__NO_SIDE_EFFECTS__
function ea(e) {
	return e ? e.__v_isRef === !0 : !1;
}
function ta(e) {
	return /* @__PURE__ */ ea(e) ? e.value : e;
}
var na = {
	get: (e, t, n) => t === "__v_raw" ? e : ta(Reflect.get(e, t, n)),
	set: (e, t, n, r) => {
		let i = e[t];
		return /* @__PURE__ */ ea(i) && !/* @__PURE__ */ ea(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
	}
};
function ra(e) {
	return /* @__PURE__ */ qi(e) ? e : new Proxy(e, na);
}
var ia = {}, aa = /* @__PURE__ */ new WeakMap(), oa = void 0;
function sa(e, t = !1, n = oa) {
	if (n) {
		let t = aa.get(n);
		t || aa.set(n, t = []), t.push(e);
	} else process.env.NODE_ENV !== "production" && !t && Nr("onWatcherCleanup() was called when there was no active watcher to associate with.");
}
function ca(e, t, n = ir) {
	let { immediate: r, deep: i, once: a, scheduler: o, augmentJob: s, call: c } = n, l = (e) => {
		(n.onWarn || Nr)("Invalid watch source: ", e, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
	}, u = (e) => i ? e : /* @__PURE__ */ Yi(e) || i === !1 || i === 0 ? la(e, 1) : la(e), d, f, p, m, h = !1, g = !1;
	if (/* @__PURE__ */ ea(e) ? (f = () => e.value, h = /* @__PURE__ */ Yi(e)) : /* @__PURE__ */ qi(e) ? (f = () => u(e), h = !0) : w(e) ? (g = !0, h = e.some((e) => /* @__PURE__ */ qi(e) || /* @__PURE__ */ Yi(e)), f = () => e.map((e) => {
		if (/* @__PURE__ */ ea(e)) return e.value;
		if (/* @__PURE__ */ qi(e)) return u(e);
		if (T(e)) return c ? c(e, 2) : e();
		process.env.NODE_ENV !== "production" && l(e);
	})) : T(e) ? f = t ? c ? () => c(e, 2) : e : () => {
		if (p) {
			Xr();
			try {
				p();
			} finally {
				Zr();
			}
		}
		let t = oa;
		oa = d;
		try {
			return c ? c(e, 3, [m]) : e(m);
		} finally {
			oa = t;
		}
	} : (f = ar, process.env.NODE_ENV !== "production" && l(e)), t && i) {
		let e = f, t = i === !0 ? Infinity : i;
		f = () => la(e(), t);
	}
	let _ = () => {
		d.stop();
	};
	if (a && t) {
		let e = t;
		t = (...t) => {
			let n = e(...t);
			return _(), n;
		};
	}
	let v = g ? Array(e.length).fill(ia) : ia, y = (e) => {
		if (!(!(d.flags & 1) || !d.dirty && !e)) {
			if (t) {
				let n = d.run();
				if (e || i || h || (g ? n.some((e, t) => Cr(e, v[t])) : Cr(n, v))) {
					p && p();
					let e = oa;
					oa = d;
					try {
						let e = [
							n,
							v === ia ? void 0 : g && v[0] === ia ? [] : v,
							m
						];
						v = n, c ? c(t, 3, e) : t(...e);
					} finally {
						oa = e;
					}
				}
			} else d.run();
		}
	};
	return s && s(y), d = new Fr(f), d.scheduler = o ? () => o(y, !1) : y, m = (e) => sa(e, !1, d), p = d.onStop = () => {
		let e = aa.get(d);
		if (e) {
			if (c) c(e, 4);
			else for (let t of e) t();
			aa.delete(d);
		}
	}, process.env.NODE_ENV !== "production" && (d.onTrack = n.onTrack, d.onTrigger = n.onTrigger), t ? r ? y(!0) : v = d.run() : o ? o(y.bind(null, !0), !0) : d.run(), _.pause = d.pause.bind(d), _.resume = d.resume.bind(d), _.stop = _, _;
}
function la(e, t = Infinity, n) {
	if (t <= 0 || !hr(e) || e.__v_skip || (n ||= /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t)) return e;
	if (n.set(e, t), t--, /* @__PURE__ */ ea(e)) la(e.value, t, n);
	else if (w(e)) for (let r = 0; r < e.length; r++) la(e[r], t, n);
	else if (fr(e) || dr(e)) e.forEach((e) => {
		la(e, t, n);
	});
	else if (br(e)) {
		for (let r in e) la(e[r], t, n);
		for (let r of Object.getOwnPropertySymbols(e)) Object.prototype.propertyIsEnumerable.call(e, r) && la(e[r], t, n);
	}
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+runtime-core@3.5.41/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
var ua = [];
function da(e) {
	ua.push(e);
}
function fa() {
	ua.pop();
}
var pa = !1;
function O(e, ...t) {
	if (pa) return;
	pa = !0, Xr();
	let n = ua.length ? ua[ua.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = ma();
	if (r) ba(r, n, 11, [
		e + t.map((e) => e.toString?.call(e) ?? JSON.stringify(e)).join(""),
		n && n.proxy,
		i.map(({ vnode: e }) => `at <${ts(n, e.type)}>`).join("\n"),
		i
	]);
	else {
		let n = [`[Vue warn]: ${e}`, ...t];
		i.length && n.push("\n", ...ha(i)), console.warn(...n);
	}
	Zr(), pa = !1;
}
function ma() {
	let e = ua[ua.length - 1];
	if (!e) return [];
	let t = [];
	for (; e;) {
		let n = t[0];
		n && n.vnode === e ? n.recurseCount++ : t.push({
			vnode: e,
			recurseCount: 0
		});
		let r = e.component && e.component.parent;
		e = r && r.vnode;
	}
	return t;
}
function ha(e) {
	let t = [];
	return e.forEach((e, n) => {
		t.push(...n === 0 ? [] : ["\n"], ...ga(e));
	}), t;
}
function ga({ vnode: e, recurseCount: t }) {
	let n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${ts(e.component, e.type, r)}`, a = ">" + n;
	return e.props ? [
		i,
		..._a(e.props),
		a
	] : [i + a];
}
function _a(e) {
	let t = [], n = Object.keys(e);
	return n.slice(0, 3).forEach((n) => {
		t.push(...va(n, e[n]));
	}), n.length > 3 && t.push(" ..."), t;
}
function va(e, t, n) {
	return pr(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : /* @__PURE__ */ ea(t) ? (t = va(e, /* @__PURE__ */ D(t.value), !0), n ? t : [
		`${e}=Ref<`,
		t,
		">"
	]) : T(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = /* @__PURE__ */ D(t), n ? t : [`${e}=`, t]);
}
var ya = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function ba(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		Sa(e, t, n);
	}
}
function xa(e, t, n, r) {
	if (T(e)) {
		let i = ba(e, t, n, r);
		return i && gr(i) && i.catch((e) => {
			Sa(e, t, n);
		}), i;
	}
	if (w(e)) {
		let i = [];
		for (let a = 0; a < e.length; a++) i.push(xa(e[a], t, n, r));
		return i;
	}
	process.env.NODE_ENV !== "production" && O(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
}
function Sa(e, t, n, r = !0) {
	let i = t ? t.vnode : null, { errorHandler: a, throwUnhandledErrorInProduction: o } = t && t.appContext.config || ir;
	if (t) {
		let r = t.parent, i = t.proxy, o = process.env.NODE_ENV === "production" ? `https://vuejs.org/error-reference/#runtime-${n}` : ya[n];
		for (; r;) {
			let t = r.ec;
			if (t) {
				for (let n = 0; n < t.length; n++) if (t[n](e, i, o) === !1) return;
			}
			r = r.parent;
		}
		if (a) {
			Xr(), ba(a, null, 10, [
				e,
				i,
				o
			]), Zr();
			return;
		}
	}
	Ca(e, n, i, r, o);
}
function Ca(e, t, n, r = !0, i = !1) {
	if (process.env.NODE_ENV !== "production") {
		let i = ya[t];
		if (n && da(n), O(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && fa(), r) throw e;
		console.error(e);
	} else if (i) throw e;
	else console.error(e);
}
var wa = [], Ta = -1, Ea = [], Da = null, Oa = 0, ka = /* @__PURE__ */ Promise.resolve(), Aa = null, ja = 100;
function Ma(e) {
	let t = Aa || ka;
	return e ? t.then(this ? e.bind(this) : e) : t;
}
function Na(e) {
	let t = Ta + 1, n = wa.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = wa[r], a = Ra(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function Pa(e) {
	if (!(e.flags & 1)) {
		let t = Ra(e), n = wa[wa.length - 1];
		!n || !(e.flags & 2) && t >= Ra(n) ? wa.push(e) : wa.splice(Na(t), 0, e), e.flags |= 1, Fa();
	}
}
function Fa() {
	Aa ||= ka.then(za);
}
function Ia(e) {
	if (!w(e)) Da && e.id === -1 ? Da.splice(Oa + 1, 0, e) : e.flags & 1 || (Ea.push(e), e.flags |= 1);
	else for (let t = 0; t < e.length; t++) Ea.push(e[t]);
	Fa();
}
function La(e) {
	if (Ea.length) {
		let t = [...new Set(Ea)].sort((e, t) => Ra(e) - Ra(t));
		if (Ea.length = 0, Da) {
			for (let e = 0; e < t.length; e++) Da.push(t[e]);
			return;
		}
		for (Da = t, process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map()), Oa = 0; Oa < Da.length; Oa++) {
			let t = Da[Oa];
			process.env.NODE_ENV !== "production" && Ba(e, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
		}
		Da = null, Oa = 0;
	}
}
var Ra = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function za(e) {
	process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map());
	let t = process.env.NODE_ENV === "production" ? ar : (t) => Ba(e, t);
	try {
		for (Ta = 0; Ta < wa.length; Ta++) {
			let e = wa[Ta];
			if (e && !(e.flags & 8)) {
				if (process.env.NODE_ENV !== "production" && t(e)) continue;
				e.flags & 4 && (e.flags &= -2), ba(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2);
			}
		}
	} finally {
		for (; Ta < wa.length; Ta++) {
			let e = wa[Ta];
			e && (e.flags &= -2);
		}
		Ta = -1, wa.length = 0, La(e), Aa = null, (wa.length || Ea.length) && za(e);
	}
}
function Ba(e, t) {
	let n = e.get(t) || 0;
	if (n > ja) {
		let e = t.i, n = e && es(e.type);
		return Sa(`Maximum recursive updates exceeded${n ? ` in component <${n}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10), !0;
	}
	return e.set(t, n + 1), !1;
}
var Va = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (Er().__VUE_HMR_RUNTIME__ = {
	createRecord: Ja(Ua),
	rerender: Ja(Ga),
	reload: Ja(Ka)
});
var Ha = /* @__PURE__ */ new Map();
function Ua(e, t) {
	return !Ha.has(e) && (Ha.set(e, {
		initialDef: Wa(t),
		instances: /* @__PURE__ */ new Set()
	}), !0);
}
function Wa(e) {
	return ns(e) ? e.__vccOpts : e;
}
function Ga(e, t) {
	let n = Ha.get(e);
	n && (n.initialDef.render = t, [...n.instances].forEach((e) => {
		t && (e.render = t, Wa(e.type).render = t), e.renderCache = [], e.job.flags & 8 || e.update();
	}));
}
function Ka(e, t) {
	let n = Ha.get(e);
	if (!n) return;
	t = Wa(t), qa(n.initialDef, t);
	let r = [...n.instances];
	for (let e = 0; e < r.length; e++) {
		let i = r[e], a = Wa(i.type), o = Va.get(a);
		o || (a !== n.initialDef && qa(a, t), Va.set(a, o = /* @__PURE__ */ new Set())), o.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (o.add(i), i.ceReload(t.styles), o.delete(i)) : i.parent ? Pa(() => {
			i.job.flags & 8 || (i.parent.update(), o.delete(i));
		}) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn("[HMR] Root or manually mounted instance modified. Full reload required."), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(a);
	}
	Ia(() => {
		Va.clear();
	});
}
function qa(e, t) {
	cr(e, t);
	for (let n in e) n !== "__file" && !(n in t) && delete e[n];
}
function Ja(e) {
	return (t, n) => {
		try {
			return e(t, n);
		} catch (e) {
			console.error(e), console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
		}
	};
}
var Ya = null, Xa = null;
function Za(e, t, n = !1) {
	let r = Ko();
	if (r || So) {
		let i = So ? So._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
		if (i && e in i) return i[e];
		if (arguments.length > 1) return n && T(t) ? t.call(r && r.proxy) : t;
		process.env.NODE_ENV !== "production" && O(`injection "${String(e)}" not found.`);
	} else process.env.NODE_ENV !== "production" && O("inject() can only be used inside setup() or functional components.");
}
var Qa = /* @__PURE__ */ Symbol.for("v-scx"), $a = () => {
	{
		let e = Za(Qa);
		return e || process.env.NODE_ENV !== "production" && O("Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."), e;
	}
};
function eo(e, t, n = ir) {
	let { immediate: r, deep: i, flush: a, once: o } = n;
	process.env.NODE_ENV !== "production" && !t && (r !== void 0 && O("watch() \"immediate\" option is only respected when using the watch(source, callback, options?) signature."), i !== void 0 && O("watch() \"deep\" option is only respected when using the watch(source, callback, options?) signature."), o !== void 0 && O("watch() \"once\" option is only respected when using the watch(source, callback, options?) signature."));
	let s = cr({}, n);
	process.env.NODE_ENV !== "production" && (s.onWarn = O);
	let c = t && r || !t && a !== "post", l;
	if (Xo) {
		if (a === "sync") {
			let e = $a();
			l = e.__watcherHandles ||= [];
		} else if (!c) {
			let e = () => {};
			return e.stop = ar, e.resume = ar, e.pause = ar, e;
		}
	}
	let u = Go;
	s.call = (e, t, n) => xa(e, u, t, n);
	let d = !1;
	a === "post" ? s.scheduler = (e) => {
		To(e, u && u.suspense);
	} : a !== "sync" && (d = !0, s.scheduler = (e, t) => {
		t ? e() : Pa(e);
	}), s.augmentJob = (e) => {
		t && (e.flags |= 4), d && (e.flags |= 2, u && (e.id = u.uid, e.i = u));
	};
	let f = ca(e, t, s);
	return Xo && (l ? l.push(f) : c && f()), f;
}
function to(e, t, n) {
	let r = this.proxy, i = pr(e) ? e.includes(".") ? no(r, e) : () => r[e] : e.bind(r, r), a;
	T(t) ? a = t : (a = t.handler, n = t);
	let o = Jo(this), s = eo(i, a.bind(r), n);
	return o(), s;
}
function no(e, t) {
	let n = t.split(".");
	return () => {
		let t = e;
		for (let e = 0; e < n.length && t; e++) t = t[n[e]];
		return t;
	};
}
var ro = (e) => e.__isTeleport;
function io(e) {
	let t = e[0];
	if (e.length > 1) {
		let n = !1;
		for (let r of e) if (r.type !== Ao) {
			if (process.env.NODE_ENV !== "production" && n) {
				O("<transition> can only be used on a single element or component. Use <transition-group> for lists.");
				break;
			}
			if (t = r, n = !0, process.env.NODE_ENV === "production") break;
		}
	}
	return t;
}
function ao(e) {
	if (!so(e)) return ro(e.type) && e.children ? io(e.children) : e;
	if (e.component) return e.component.subTree;
	let { shapeFlag: t, children: n } = e;
	if (n) {
		if (t & 16) return n[0];
		if (t & 32 && T(n.default)) return n.default();
	}
}
function oo(e, t) {
	if (e.shapeFlag & 6 && e.component) {
		e.transition = t;
		let n = e.component.subTree;
		oo(ro(n.type) && ao(n) || n, t);
	} else e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
Er().requestIdleCallback, Er().cancelIdleCallback;
var so = (e) => e.type.__isKeepAlive, co = /* @__PURE__ */ Symbol.for("v-ndc"), lo = (e) => e ? Yo(e) ? Zo(e) : lo(e.parent) : null, uo = /* @__PURE__ */ cr(/* @__PURE__ */ Object.create(null), {
	$: (e) => e,
	$el: (e) => e.vnode.el,
	$data: (e) => e.data,
	$props: (e) => process.env.NODE_ENV === "production" ? e.props : /* @__PURE__ */ Gi(e.props),
	$attrs: (e) => process.env.NODE_ENV === "production" ? e.attrs : /* @__PURE__ */ Gi(e.attrs),
	$slots: (e) => process.env.NODE_ENV === "production" ? e.slots : /* @__PURE__ */ Gi(e.slots),
	$refs: (e) => process.env.NODE_ENV === "production" ? e.refs : /* @__PURE__ */ Gi(e.refs),
	$parent: (e) => lo(e.parent),
	$root: (e) => lo(e.root),
	$host: (e) => e.ce,
	$emit: (e) => e.emit,
	$options: (e) => __VUE_OPTIONS_API__ ? po(e) : e.type,
	$forceUpdate: (e) => e.f ||= () => {
		Pa(e.update);
	},
	$nextTick: (e) => e.n ||= Ma.bind(e.proxy),
	$watch: (e) => __VUE_OPTIONS_API__ ? to.bind(e) : ar
});
process.env.NODE_ENV;
function fo(e) {
	return w(e) ? e.reduce((e, t) => (e[t] = null, e), {}) : e;
}
function po(e) {
	let t = e.type, { mixins: n, extends: r } = t, { mixins: i, optionsCache: a, config: { optionMergeStrategies: o } } = e.appContext, s = a.get(t), c;
	return s ? c = s : !i.length && !n && !r ? c = t : (c = {}, i.length && i.forEach((e) => mo(c, e, o, !0)), mo(c, t, o)), hr(t) && a.set(t, c), c;
}
function mo(e, t, n, r = !1) {
	let { mixins: i, extends: a } = t;
	a && mo(e, a, n, !0), i && i.forEach((t) => mo(e, t, n, !0));
	for (let i in t) if (r && i === "expose") process.env.NODE_ENV !== "production" && O("\"expose\" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.");
	else {
		let r = ho[i] || n && n[i];
		e[i] = r ? r(e[i], t[i]) : t[i];
	}
	return e;
}
var ho = {
	data: go,
	props: bo,
	emits: bo,
	methods: yo,
	computed: yo,
	beforeCreate: k,
	created: k,
	beforeMount: k,
	mounted: k,
	beforeUpdate: k,
	updated: k,
	beforeDestroy: k,
	beforeUnmount: k,
	destroyed: k,
	unmounted: k,
	activated: k,
	deactivated: k,
	errorCaptured: k,
	serverPrefetch: k,
	components: yo,
	directives: yo,
	watch: xo,
	provide: go,
	inject: _o
};
function go(e, t) {
	return t ? e ? function() {
		return cr(T(e) ? e.call(this, this) : e, T(t) ? t.call(this, this) : t);
	} : t : e;
}
function _o(e, t) {
	return yo(vo(e), vo(t));
}
function vo(e) {
	if (w(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
		return t;
	}
	return e;
}
function k(e, t) {
	return e ? [...new Set([].concat(e, t))] : t;
}
function yo(e, t) {
	return e ? cr(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function bo(e, t) {
	return e ? w(e) && w(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : cr(/* @__PURE__ */ Object.create(null), fo(e), fo(t ?? {})) : t;
}
function xo(e, t) {
	if (!e) return t;
	if (!t) return e;
	let n = cr(/* @__PURE__ */ Object.create(null), e);
	for (let r in t) n[r] = k(e[r], t[r]);
	return n;
}
var So = null, Co = {}, wo = (e) => Object.getPrototypeOf(e) === Co, To = Do, Eo = (e) => e.__isSuspense;
function Do(e, t) {
	t && t.pendingBranch ? w(e) ? t.effects.push(...e) : t.effects.push(e) : Ia(e);
}
var Oo = /* @__PURE__ */ Symbol.for("v-fgt"), ko = /* @__PURE__ */ Symbol.for("v-txt"), Ao = /* @__PURE__ */ Symbol.for("v-cmt");
function jo(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
var Mo = (...e) => Ro(...e), No = ({ key: e }) => e ?? null, Po = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : pr(e) || /* @__PURE__ */ ea(e) || T(e) ? {
	i: Ya,
	r: e,
	k: t,
	f: !!n
} : e);
function Fo(e, t = null, n = null, r = 0, i = null, a = e === Oo ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && No(t),
		ref: t && Po(t),
		scopeId: Xa,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: Ya
	};
	if (s ? (Uo(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= pr(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && O("VNode created with invalid key (NaN). VNode type:", c.type), process.env.NODE_ENV !== "production" && t && c.shapeFlag & 1) {
		let e = t.innerHTML == null ? t.textContent == null ? null : "textContent" : "innerHTML";
		e && Io(c.children) && O(`The \`${e}\` prop on <${c.type}> will override its children. Remove either the \`${e}\` prop or the children.`);
	}
	return c;
}
function Io(e) {
	return pr(e) ? e !== "" : w(e) ? e.length > 0 : !1;
}
var Lo = process.env.NODE_ENV === "production" ? Ro : Mo;
function Ro(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === co) && (process.env.NODE_ENV !== "production" && !e && O(`Invalid vnode type when creating vnode: ${e}.`), e = Ao), jo(e)) {
		let r = Bo(e, t, !0);
		return n && Uo(r, n), r.patchFlag = -2, r;
	}
	if (ns(e) && (e = e.__vccOpts), t) {
		t = zo(t);
		let { class: e, style: n } = t;
		e && !pr(e) && (t.class = Mr(e)), hr(n) && (/* @__PURE__ */ Xi(n) && !w(n) && (n = cr({}, n)), t.style = Dr(n));
	}
	let o = pr(e) ? 1 : Eo(e) ? 128 : ro(e) ? 64 : hr(e) ? 4 : T(e) ? 2 : 0;
	return process.env.NODE_ENV !== "production" && o & 4 && /* @__PURE__ */ Xi(e) && (e = /* @__PURE__ */ D(e), O("Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.", "\nComponent that was made reactive: ", e)), Fo(e, t, n, r, i, o, a, !0);
}
function zo(e) {
	return e ? /* @__PURE__ */ Xi(e) || wo(e) ? cr({}, e) : e : null;
}
function Bo(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? Wo(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && No(l),
		ref: t && t.ref ? n && a ? w(a) ? a.concat(Po(t)) : [a, Po(t)] : Po(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: process.env.NODE_ENV !== "production" && o === -1 && w(s) ? s.map(Vo) : s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== Oo ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && Bo(e.ssContent),
		ssFallback: e.ssFallback && Bo(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && oo(u, c.clone(u)), u;
}
function Vo(e) {
	let t = Bo(e);
	return w(e.children) && (t.children = e.children.map(Vo)), t;
}
function Ho(e = " ", t = 0) {
	return Lo(ko, null, e, t);
}
function Uo(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (w(t)) n = 16;
	else if (typeof t == "object") {
		if (r & 65) {
			let n = t.default;
			n && (n._c && (n._d = !1), Uo(e, n()), n._c && (n._d = !0));
			return;
		}
		n = 32, !t._ && !wo(t) && (t._ctx = Ya);
	} else if (T(t)) {
		if (r & 65) {
			Uo(e, { default: t });
			return;
		}
		t = {
			default: t,
			_ctx: Ya
		}, n = 32;
	} else t = String(t), r & 64 ? (n = 16, t = [Ho(t)]) : n = 8;
	e.children = t, e.shapeFlag |= n;
}
function Wo(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = Mr([t.class, r.class]));
		else if (e === "style") t.style = Dr([t.style, r.style]);
		else if (or(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(w(n) && n.includes(i)) ? t[e] = n ? [].concat(n, i) : i : i == null && n == null && !sr(e) && (t[e] = i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
var Go = null, Ko = () => Go || Ya, qo;
{
	let e = Er(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	qo = t("__VUE_INSTANCE_SETTERS__", (e) => Go = e), t("__VUE_SSR_SETTERS__", (e) => Xo = e);
}
var Jo = (e) => {
	let t = Go;
	return qo(e), e.scope.on(), () => {
		e.scope.off(), qo(t);
	};
};
function Yo(e) {
	return e.vnode.shapeFlag & 4;
}
var Xo = !1;
process.env.NODE_ENV;
function Zo(e) {
	return e.exposed ? e.exposeProxy ||= new Proxy(ra(Zi(e.exposed)), {
		get(t, n) {
			if (n in t) return t[n];
			if (n in uo) return uo[n](e);
		},
		has(e, t) {
			return t in e || t in uo;
		}
	}) : e.proxy;
}
var Qo = /(?:^|[-_])\w/g, $o = (e) => e.replace(Qo, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function es(e, t = !0) {
	return T(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function ts(e, t, n = !1) {
	let r = es(t);
	if (!r && t.__file) {
		let e = t.__file.match(/([^/\\]+)\.\w+$/);
		e && (r = e[1]);
	}
	if (!r && e) {
		let n = (e) => {
			for (let n in e) if (e[n] === t) return n;
		};
		r = n(e.components) || e.parent && n(e.parent.type.components) || n(e.appContext.components);
	}
	return r ? $o(r) : n ? "App" : "Anonymous";
}
function ns(e) {
	return T(e) && "__vccOpts" in e;
}
function rs() {
	if (process.env.NODE_ENV === "production" || typeof window > "u") return;
	let e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, i = {
		__vue_custom_formatter: !0,
		header(t) {
			if (!hr(t)) return null;
			if (t.__isVue) return [
				"div",
				e,
				"VueInstance"
			];
			if (/* @__PURE__ */ ea(t)) {
				Xr();
				let n = t.value;
				return Zr(), [
					"div",
					{},
					[
						"span",
						e,
						u(t)
					],
					"<",
					s(n),
					">"
				];
			}
			return /* @__PURE__ */ qi(t) ? [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ Yi(t) ? "ShallowReactive" : "Reactive"
				],
				"<",
				s(t),
				`>${/* @__PURE__ */ Ji(t) ? " (readonly)" : ""}`
			] : /* @__PURE__ */ Ji(t) ? [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ Yi(t) ? "ShallowReadonly" : "Readonly"
				],
				"<",
				s(t),
				">"
			] : null;
		},
		hasBody(e) {
			return e && e.__isVue;
		},
		body(e) {
			if (e && e.__isVue) return [
				"div",
				{},
				...a(e.$)
			];
		}
	};
	function a(e) {
		let t = [];
		e.type.props && e.props && t.push(o("props", /* @__PURE__ */ D(e.props))), e.setupState !== ir && t.push(o("setup", e.setupState)), e.data !== ir && t.push(o("data", /* @__PURE__ */ D(e.data)));
		let n = c(e, "computed");
		n && t.push(o("computed", n));
		let i = c(e, "inject");
		return i && t.push(o("injected", i)), t.push([
			"div",
			{},
			[
				"span",
				{ style: r.style + ";opacity:0.66" },
				"$ (internal): "
			],
			["object", { object: e }]
		]), t;
	}
	function o(e, t) {
		return t = cr({}, t), Object.keys(t).length ? [
			"div",
			{ style: "line-height:1.25em;margin-bottom:0.6em" },
			[
				"div",
				{ style: "color:#476582" },
				e
			],
			[
				"div",
				{ style: "padding-left:1.25em" },
				...Object.keys(t).map((e) => [
					"div",
					{},
					[
						"span",
						r,
						e + ": "
					],
					s(t[e], !1)
				])
			]
		] : ["span", {}];
	}
	function s(e, i = !0) {
		return typeof e == "number" ? [
			"span",
			t,
			e
		] : typeof e == "string" ? [
			"span",
			n,
			JSON.stringify(e)
		] : typeof e == "boolean" ? [
			"span",
			r,
			e
		] : hr(e) ? ["object", { object: i ? /* @__PURE__ */ D(e) : e }] : [
			"span",
			n,
			String(e)
		];
	}
	function c(e, t) {
		let n = e.type;
		if (T(n)) return;
		let r = {};
		for (let i in e.ctx) l(n, i, t) && (r[i] = e.ctx[i]);
		return r;
	}
	function l(e, t, n) {
		let r = e[n];
		if (w(r) && r.includes(t) || hr(r) && t in r || e.extends && l(e.extends, t, n) || e.mixins && e.mixins.some((e) => l(e, t, n))) return !0;
	}
	function u(e) {
		return /* @__PURE__ */ Yi(e) ? "ShallowRef" : e.effect ? "ComputedRef" : "Ref";
	}
	window.devtoolsFormatters ? window.devtoolsFormatters.push(i) : window.devtoolsFormatters = [i];
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV;
//#endregion
//#region ../../node_modules/.pnpm/vue@3.5.41_typescript@6.0.3/node_modules/vue/dist/vue.runtime.esm-bundler.js
function is() {
	rs();
}
process.env.NODE_ENV !== "production" && is();
//#endregion
//#region src/events/matchOrderEvent.ts
var as = (e, t) => {
	let n = e.message;
	if (n) switch (n.case) {
		case un.OrderAlreadyDiscovered:
			t.onAlreadyDiscovered?.(n.value);
			break;
		case un.OrderCreated:
			t.onCreated?.(n.value);
			break;
		case un.OrderUpdated:
			t.onUpdated?.(n.value);
			break;
		case un.OrderDeleted:
			t.onDeleted?.(n.value);
			break;
		case un.OrderRulesEvaluated: t.onRuleEvaluated?.(n.value);
	}
}, os = {
	CommercialGoods: "COMMERCIAL_GOODS",
	CommercialSample: "COMMERCIAL_SAMPLE",
	Documents: "DOCUMENTS",
	Gift: "GIFT",
	ReturnedGoods: "RETURNED_GOODS"
}, ss = {
	PickingAndPacking: "PICKING_AND_PACKING",
	Dispatching: "DISPATCHING",
	Untraceable: "UNTRACEABLE",
	Sorting: "SORTING",
	Distributing: "DISTRIBUTING",
	Delivered: "DELIVERED"
}, cs = (e) => e.type === "BUSINESS" || "company" in e && typeof e.company == "string" && e.company.length > 0, ls = (e) => e.type === "PRIVATE" || "name" in e && typeof e.name == "string";
//#endregion
//#region src/typeguards/label.ts
function us(e) {
	return e !== void 0 && "barcode" in e;
}
function ds(e) {
	return e !== void 0 && !("barcode" in e);
}
//#endregion
//#region ../../libs/types/dist/index.js
var A = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, j = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
A.Dhl, A.Instabox, A.PostNl, j.PostNl, A.Bpost, j.Bpost, A.CheapCargo, j.CheapCargo, A.Dpd, j.Dpd, A.Instabox, j.Instabox, A.Dhl, j.Dhl, A.Bol, j.Bol, A.Ups, j.Ups, A.DhlForYou, j.DhlForYou, A.DhlParcelConnect, j.DhlParcelConnect, A.DhlEuroPlus, j.DhlEuroPlus, A.UpsStandard, j.UpsStandard, A.UpsExpressSaver, j.UpsExpressSaver, A.Gls, j.Gls, A.Brt, j.Brt, A.Trunkrs, j.Trunkrs, A.InPost, j.InPost, A.PosteItaliane, j.PosteItaliane, A.Spring, j.Spring, A.ViaTim, j.ViaTim, A.DhlFreight, j.DhlFreight, A.PostNl, j.POSTNL, A.Bpost, j.BPOST, A.CheapCargo, j.CHEAP_CARGO, A.Dpd, j.DPD, A.Instabox, j.INSTABOX, A.Dhl, j.DHL, A.Bol, j.BOL, A.Ups, j.UPS, A.DhlForYou, j.DHL_FOR_YOU, A.DhlParcelConnect, j.DHL_PARCEL_CONNECT, A.DhlEuroPlus, j.DHL_EUROPLUS, A.UpsStandard, j.UPS_STANDARD, A.UpsExpressSaver, j.UPS_EXPRESS_SAVER, A.Gls, j.GLS, A.Brt, j.BRT, A.Trunkrs, j.TRUNKRS, A.InPost, j.INPOST, A.PosteItaliane, j.POSTE_ITALIANE, A.Spring, j.SPRING, A.ViaTim, j.VIA_TIM, A.DhlFreight, j.DHL_FREIGHT, j.POSTNL, A.PostNl, j.BPOST, A.Bpost, j.CHEAP_CARGO, A.CheapCargo, j.DPD, A.Dpd, j.INSTABOX, A.Instabox, j.DHL, A.Dhl, j.BOL, A.Bol, j.UPS, A.Ups, j.DHL_FOR_YOU, A.DhlForYou, j.DHL_PARCEL_CONNECT, A.DhlParcelConnect, j.DHL_EUROPLUS, A.DhlEuroPlus, j.UPS_STANDARD, A.UpsStandard, j.UPS_EXPRESS_SAVER, A.UpsExpressSaver, j.GLS, A.Gls, j.BRT, A.Brt, j.TRUNKRS, A.Trunkrs, j.INPOST, A.InPost, j.POSTE_ITALIANE, A.PosteItaliane, j.SPRING, A.Spring, j.VIA_TIM, A.ViaTim, j.DHL_FREIGHT, A.DhlFreight, j.PostNl, A.PostNl, j.POSTNL, A.PostNl, j.Bpost, A.Bpost, j.BPOST, A.Bpost, j.CheapCargo, A.CheapCargo, j.CHEAP_CARGO, A.CheapCargo, j.Dpd, A.Dpd, j.DPD, A.Dpd, j.Instabox, A.Instabox, j.Dhl, A.Dhl, j.BolCom, A.Bol, j.Bol, A.Bol, j.BOL, A.Bol, j.Ups, A.Ups, j.DhlForYou, A.DhlForYou, j.DHL_FOR_YOU, A.DhlForYou, j.DhlParcelConnect, A.DhlParcelConnect, j.DHL_PARCEL_CONNECT, A.DhlParcelConnect, j.DhlEuroPlus, A.DhlEuroPlus, j.DHL_EUROPLUS, A.DhlEuroPlus, j.UpsStandard, A.UpsStandard, j.UPS_STANDARD, A.UpsStandard, j.UpsExpressSaver, A.UpsExpressSaver, j.UPS_EXPRESS_SAVER, A.UpsExpressSaver, j.Gls, A.Gls, j.GLS, A.Gls, j.Brt, A.Brt, j.BRT, A.Brt, j.Trunkrs, A.Trunkrs, j.TRUNKRS, A.Trunkrs, j.InPost, A.InPost, j.INPOST, A.InPost, j.PosteItaliane, A.PosteItaliane, j.POSTE_ITALIANE, A.PosteItaliane, j.Spring, A.Spring, j.SPRING, A.Spring, j.ViaTim, A.ViaTim, j.VIA_TIM, A.ViaTim, j.DhlFreight, A.DhlFreight, j.DHL_FREIGHT, A.DhlFreight, A.PostNl, A.Bpost, A.CheapCargo, A.Dpd, A.Instabox, A.Dhl, A.Bol, A.Ups, A.DhlForYou, A.DhlParcelConnect, A.DhlEuroPlus, A.UpsStandard, A.UpsExpressSaver, A.Gls, A.Brt, A.Trunkrs, A.InPost, A.PosteItaliane, A.Spring, A.ViaTim, A.DhlFreight;
var M = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
M.Austria, M.Belgium, M.Bulgaria, M.Croatia, M.Cyprus, M.CzechRepublic, M.Denmark, M.Estonia, M.Finland, M.France, M.Germany, M.Greece, M.Hungary, M.Ireland, M.Italy, M.Latvia, M.Lithuania, M.Luxembourg, M.Malta, M.Netherlands, M.Poland, M.Portugal, M.Romania, M.Slovakia, M.Slovenia, M.Spain, M.Sweden, Object.values(M), M.Angola, M.AntiguaAndBarbuda, M.Aruba, M.Bahamas, M.Belize, M.Benin, M.Bermuda, M.BonaireSintEustatiusAndSaba, M.Botswana, M.BurkinaFaso, M.Burundi, M.Cameroon, M.CanaryIslands, M.CentralAfricanRepublic, M.Comoros, M.CongoBrazzaville, M.CongoKinshasa, M.CoteDIvoire, M.Curacao, M.Djibouti, M.Dominica, M.DutchAntilles, M.EquatorialGuinea, M.Eritrea, M.Fiji, M.Gabon, M.Gambia, M.Ghana, M.Grenada, M.Guyana, M.HongKong, M.Kiribati, M.KoreaPeoplesDemocraticRepublic, M.Macao, M.Malawi, M.Mali, M.Mauritania, M.Nauru, M.Qatar, M.Rwanda, M.SaintKittsAndNevis, M.SaoTomeAndPrincipe, M.Seychelles, M.SierraLeone, M.SintMaarten, M.Suriname, M.SyrianArabRepublic, M.TimorLeste, M.Togo, M.Tonga, M.Tuvalu, M.Uganda, M.UnitedArabEmirates, M.Vanuatu, M.Yemen, M.Zimbabwe, M.Austria, M.Belgium, M.Bulgaria, M.Croatia, M.CzechRepublic, M.Estonia, M.Finland, M.France, M.Germany, M.Greece, M.Hungary, M.Ireland, M.Italy, M.Latvia, M.Lithuania, M.Luxembourg, M.Malta, M.Netherlands, M.Portugal, M.Romania, M.Slovakia, M.Slovenia, M.Spain, M.UnitedKingdom, M.Denmark, M.Germany, M.Sweden;
var N = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, P = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, F = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
N.EarlyMorning, P.EarlyMorning, N.Morning, P.Morning, N.Standard, P.Standard, N.Evening, P.Evening, N.Pickup, P.Pickup, N.PickupExpress, P.PickupExpress, N.SameDayDelivery, P.SameDayDelivery, N.Express, P.Express, P.EarlyMorning, N.EarlyMorning, P.Morning, N.Morning, P.Standard, N.Standard, P.Evening, N.Evening, P.Pickup, N.Pickup, P.PickupExpress, N.PickupExpress, P.SameDayDelivery, N.SameDayDelivery, P.Express, N.Express, N.EarlyMorning, F.EarlyMorning, N.Morning, F.Morning, N.Standard, F.Standard, N.Evening, F.Evening, N.Pickup, F.Pickup, N.PickupExpress, F.PickupExpress, N.SameDayDelivery, F.SameDayDelivery, N.Express, F.Express, F.EarlyMorning, P.EarlyMorning, F.Morning, P.Morning, F.Standard, P.Standard, F.Evening, P.Evening, F.Pickup, P.Pickup, F.PickupExpress, P.PickupExpress, F.SameDayDelivery, P.SameDayDelivery, F.Express, P.Express, N.EarlyMorning, N.Morning, N.Standard, N.Evening, N.Pickup, N.PickupExpress, N.SameDayDelivery, N.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var fs = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, ps = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
ps.Sunday, fs.Sunday, ps.Monday, fs.Monday, ps.Tuesday, fs.Tuesday, ps.Wednesday, fs.Wednesday, ps.Thursday, fs.Thursday, ps.Friday, fs.Friday, ps.Saturday, fs.Saturday, fs.Sunday, ps.Sunday, fs.Monday, ps.Monday, fs.Tuesday, ps.Tuesday, fs.Wednesday, ps.Wednesday, fs.Thursday, ps.Thursday, fs.Friday, ps.Friday, fs.Saturday, ps.Saturday;
var ms = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
ms.Bytes, ms.Kilobytes, ms.Megabytes, ms.Gigabytes, ms.Terabytes;
var hs = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, gs = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
hs.Bol, gs.Bol, hs.Exact, gs.Exact, hs.Amazon, gs.Amazon, hs.Wix, gs.Wix, hs.ExactDe, gs.ExactDe, hs.Etsy, gs.Etsy, gs.Bol, hs.Bol, gs.Exact, hs.Exact, gs.Amazon, hs.Amazon, gs.Wix, hs.Wix, gs.ExactDe, hs.ExactDe, gs.Etsy, hs.Etsy;
var I = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, L = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
I.Unpaid, L.Unpaid, I.Due, L.Due, I.DuePrepayment, L.DuePrepayment, I.Reminder1, L.Reminder1, I.Reminder2, L.Reminder2, I.Dun, L.Dun, I.Collection, L.Collection, I.Instalments, L.Instalments, I.PaymentArrangement, L.PaymentArrangement, I.Dispute, L.Dispute, I.LegalProcedure, L.LegalProcedure, I.Insolvency, L.Insolvency, I.WriteOff, L.WriteOff, I.Pending, L.Pending, I.Cancelled, L.Cancelled, I.Paid, L.Paid, I.PaidOnline, L.PaidOnline, I.PaidAutomatic, L.PaidAutomatic, I.PaidCredit, L.PaidCredit, I.PaidZeroItems, L.PaidZeroItems, I.InvoiceWith0InvoiceItemsPaidZeroBalance, L.PaidZeroBalance, I.Due, I.Reminder1, I.Reminder2, I.Dun, I.Collection, I.Instalments, I.PaymentArrangement, I.Dispute, I.Paid, I.PaidOnline, I.PaidAutomatic, I.PaidCredit, I.PaidZeroItems;
var _s = {
	Gram: "g",
	Kilogram: "kg"
};
_s.Gram, _s.Kilogram;
var vs = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
vs.Millimeter, vs.Centimeter, vs.Meter;
var ys = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, bs = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
bs.PendingConcept, bs.PendingRegistered, bs.EnRouteHandedToCarrier, bs.EnRouteSorting, bs.EnRouteDistribution, bs.EnRouteCustoms, bs.DeliveredReadyForPickup, bs.DeliveredAtRecipient, bs.DeliveredPackagePickedUp;
var R = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, xs = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
xs.Light, R.Light, xs.Start, R.Start, xs.Plus, R.Plus, xs.Premium, R.Premium, xs.Max, R.Max, R.Light, xs.Light, R.Start, xs.Start, R.Plus, xs.Plus, R.Premium, xs.Premium, R.Max, xs.Max;
var Ss = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, Cs = {
	Start: R.Start,
	Plus: R.Plus,
	Premium: R.Premium,
	Max: R.Max
};
Ss.Start, Cs.Start, Ss.Plus, Cs.Plus, Ss.Premium, Cs.Premium, Ss.Max, Cs.Max, Cs.Start, Ss.Start, Cs.Plus, Ss.Plus, Cs.Premium, Ss.Premium, Cs.Max, Ss.Max;
var ws = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, Ts = {
	Start: R.Start,
	Plus: R.Plus,
	Premium: R.Premium,
	Max: R.Max
};
ws.Start, Ts.Start, ws.Plus, Ts.Plus, ws.Premium, Ts.Premium, ws.Max, Ts.Max, Ts.Start, ws.Start, Ts.Plus, ws.Plus, Ts.Premium, ws.Premium, Ts.Max, ws.Max;
var Es = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, Ds = {
	Light: R.Light,
	Start: R.Start,
	Plus: R.Plus,
	Premium: R.Premium,
	Max: R.Max
};
Es.Light, Ds.Light, Es.Start, Ds.Start, Es.Plus, Ds.Plus, Es.Premium, Ds.Premium, Es.Max, Ds.Max, Ds.Light, Es.Light, Ds.Start, Es.Start, Ds.Plus, Es.Plus, Ds.Premium, Es.Premium, Ds.Max, Es.Max;
var Os = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, ks = {
	Start: R.Start,
	Plus: R.Plus,
	Premium: R.Premium,
	Max: R.Max
};
Os.Start, ks.Start, Os.Plus, ks.Plus, Os.Premium, ks.Premium, Os.Max, ks.Max, ks.Start, Os.Start, ks.Plus, Os.Plus, ks.Premium, Os.Premium, ks.Max, Os.Max;
var z = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, As = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, js = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
z.MyParcel, As.MyParcel, z.Flespakket, As.Flespakket, z.SendMyParcel, As.SendMyParcel, z.MyParcelIt, As.MyParcelIt, z.DeliverDutch, As.DeliverDutch, z.PostNlPlugin, As.PostNlPlugin, z.MyParcel, js.MyParcelNl, z.Flespakket, js.MyParcelNl, z.SendMyParcel, js.MyParcelBe, z.MyParcelIt, js.MyParcelIt, z.DeliverDutch, js.DeliverDutch, z.PostNlPlugin, js.PostNlPlugin, js.MyParcelNl, z.MyParcel, js.MyParcelBe, z.SendMyParcel, js.MyParcelIt, z.MyParcelIt, js.MyParcelNl, ys.HomeCountry, M.Netherlands, ys.Eu, ys.Row, M.Belgium, js.MyParcelBe, ys.HomeCountry, M.Belgium, M.Netherlands, ys.Eu, ys.Row, js.MyParcelBe, ys.HomeCountry, M.Belgium, ys.Eu, ys.Row, js.MyParcelNl, ys.HomeCountry, M.Netherlands, ys.Eu, ys.Row, js.MyParcelNl, ys.HomeCountry, M.Netherlands, M.Belgium, M.Luxembourg, A.Bpost, A.PostNl, A.DhlForYou, A.DhlParcelConnect, A.DhlEuroPlus, A.Ups, A.UpsStandard, A.UpsExpressSaver;
var B = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Ms = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
B.Package, Ms.Package, B.Mailbox, Ms.Mailbox, B.Letter, Ms.Letter, B.DigitalStamp, Ms.DigitalStamp, B.Pallet, Ms.Pallet, B.PackageSmall, Ms.PackageSmall, B.Envelope, Ms.Envelope, Ms.Package, B.Package, Ms.Mailbox, B.Mailbox, Ms.Letter, B.Letter, Ms.DigitalStamp, B.DigitalStamp, Ms.Pallet, B.Pallet, Ms.PackageSmall, B.PackageSmall, Ms.Envelope, B.Envelope;
var Ns = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
B.Package, Ns.PACKAGE, B.Mailbox, Ns.MAILBOX, B.Letter, Ns.UNFRANKED, B.DigitalStamp, Ns.DIGITAL_STAMP, B.Pallet, Ns.PALLET, B.PackageSmall, Ns.SMALL_PACKAGE, B.Envelope, Ns.ENVELOPE, Ns.PACKAGE, B.Package, Ns.MAILBOX, B.Mailbox, Ns.UNFRANKED, B.Letter, Ns.DIGITAL_STAMP, B.DigitalStamp, Ns.PALLET, B.Pallet, Ns.SMALL_PACKAGE, B.PackageSmall, Ns.ENVELOPE, B.Envelope, B.Package, B.Mailbox, B.Letter, B.DigitalStamp, B.Pallet, B.PackageSmall, B.Envelope;
var V = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
V.PendingConcept, V.PendingRegistered, V.EnrouteHandedToCarrier, V.EnrouteSorting, V.EnrouteDistribution, V.DeliveredAtCustoms, V.DeliveredAtRecipient, V.DeliveredPackagePickedUp, V.DeliveredReturnShipmentPackagePickedUp, V.DeliveredAtAgreedLocation, V.PrintedLetter, V.PrintedDigitalStamp, V.InactiveConcept, V.InactiveRegistered, V.InactiveEnrouteHandedToCarrier, V.InactiveEnrouteSorting, V.InactiveEnrouteDistribution, V.InactiveEnrouteCustoms, V.InactiveDeliveredAtRecipient, V.InactiveDeliveredReadyForPickup, V.InactiveDeliveredPackagePickedUp;
//#endregion
//#region src/utils/adjustedDelivery.ts
var Ps = [
	C.EVENING_DELIVERY,
	C.EARLY_MORNING_DELIVERY,
	C.MORNING_DELIVERY,
	C.STANDARD_DELIVERY
], Fs = {
	[P.EarlyMorning]: C.EARLY_MORNING_DELIVERY,
	[P.Morning]: C.MORNING_DELIVERY,
	[P.Standard]: C.STANDARD_DELIVERY,
	[P.Evening]: C.EVENING_DELIVERY,
	[P.SameDayDelivery]: C.SAME_DAY_DELIVERY,
	[P.Express]: C.EXPRESS_DELIVERY,
	[P.Pickup]: C.PICKUP_DELIVERY,
	[P.PickupExpress]: C.PICKUP_EXPRESS_DELIVERY
}, Is = {
	[C.EARLY_MORNING_DELIVERY]: P.EarlyMorning,
	[C.MORNING_DELIVERY]: P.Morning,
	[C.STANDARD_DELIVERY]: P.Standard,
	[C.EVENING_DELIVERY]: P.Evening,
	[C.SAME_DAY_DELIVERY]: P.SameDayDelivery,
	[C.EXPRESS_DELIVERY]: P.Express,
	[C.PICKUP_DELIVERY]: P.Pickup,
	[C.PICKUP_EXPRESS_DELIVERY]: P.PickupExpress
}, Ls = (e) => Is[e], Rs = (e) => Fs[e], zs = [C.PICKUP_DELIVERY, C.PICKUP_EXPRESS_DELIVERY], Bs = (e) => Ps.includes(e), Vs = (e) => zs.includes(e), Hs = (e) => e?.micros ?? 0, Us = (e, t = "EUR") => ({
	currency: t,
	micros: e
}), Ws = Object.create, Gs = Object.defineProperty, Ks = Object.getOwnPropertyDescriptor, qs = Object.getOwnPropertyNames, Js = Object.getPrototypeOf, Ys = Object.prototype.hasOwnProperty, Xs = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Zs = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = qs(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Ys.call(e, s) && s !== n && Gs(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Ks(t, s)) || r.enumerable
	});
	return e;
}, Qs = (e, t, n) => (n = e == null ? {} : Ws(Js(e)), Zs(t || !e || !e.__esModule || !Ys.call(e, "default") ? Gs(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), H = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, U = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
H.Dhl, H.Instabox, H.PostNl, U.PostNl, H.Bpost, U.Bpost, H.CheapCargo, U.CheapCargo, H.Dpd, U.Dpd, H.Instabox, U.Instabox, H.Dhl, U.Dhl, H.Bol, U.Bol, H.Ups, U.Ups, H.DhlForYou, U.DhlForYou, H.DhlParcelConnect, U.DhlParcelConnect, H.DhlEuroPlus, U.DhlEuroPlus, H.UpsStandard, U.UpsStandard, H.UpsExpressSaver, U.UpsExpressSaver, H.Gls, U.Gls, H.Brt, U.Brt, H.Trunkrs, U.Trunkrs, H.InPost, U.InPost, H.PosteItaliane, U.PosteItaliane, H.Spring, U.Spring, H.ViaTim, U.ViaTim, H.DhlFreight, U.DhlFreight, H.PostNl, U.POSTNL, H.Bpost, U.BPOST, H.CheapCargo, U.CHEAP_CARGO, H.Dpd, U.DPD, H.Instabox, U.INSTABOX, H.Dhl, U.DHL, H.Bol, U.BOL, H.Ups, U.UPS, H.DhlForYou, U.DHL_FOR_YOU, H.DhlParcelConnect, U.DHL_PARCEL_CONNECT, H.DhlEuroPlus, U.DHL_EUROPLUS, H.UpsStandard, U.UPS_STANDARD, H.UpsExpressSaver, U.UPS_EXPRESS_SAVER, H.Gls, U.GLS, H.Brt, U.BRT, H.Trunkrs, U.TRUNKRS, H.InPost, U.INPOST, H.PosteItaliane, U.POSTE_ITALIANE, H.Spring, U.SPRING, H.ViaTim, U.VIA_TIM, H.DhlFreight, U.DHL_FREIGHT, U.POSTNL, H.PostNl, U.BPOST, H.Bpost, U.CHEAP_CARGO, H.CheapCargo, U.DPD, H.Dpd, U.INSTABOX, H.Instabox, U.DHL, H.Dhl, U.BOL, H.Bol, U.UPS, H.Ups, U.DHL_FOR_YOU, H.DhlForYou, U.DHL_PARCEL_CONNECT, H.DhlParcelConnect, U.DHL_EUROPLUS, H.DhlEuroPlus, U.UPS_STANDARD, H.UpsStandard, U.UPS_EXPRESS_SAVER, H.UpsExpressSaver, U.GLS, H.Gls, U.BRT, H.Brt, U.TRUNKRS, H.Trunkrs, U.INPOST, H.InPost, U.POSTE_ITALIANE, H.PosteItaliane, U.SPRING, H.Spring, U.VIA_TIM, H.ViaTim, U.DHL_FREIGHT, H.DhlFreight, U.PostNl, H.PostNl, U.POSTNL, H.PostNl, U.Bpost, H.Bpost, U.BPOST, H.Bpost, U.CheapCargo, H.CheapCargo, U.CHEAP_CARGO, H.CheapCargo, U.Dpd, H.Dpd, U.DPD, H.Dpd, U.Instabox, H.Instabox, U.Dhl, H.Dhl, U.BolCom, H.Bol, U.Bol, H.Bol, U.BOL, H.Bol, U.Ups, H.Ups, U.DhlForYou, H.DhlForYou, U.DHL_FOR_YOU, H.DhlForYou, U.DhlParcelConnect, H.DhlParcelConnect, U.DHL_PARCEL_CONNECT, H.DhlParcelConnect, U.DhlEuroPlus, H.DhlEuroPlus, U.DHL_EUROPLUS, H.DhlEuroPlus, U.UpsStandard, H.UpsStandard, U.UPS_STANDARD, H.UpsStandard, U.UpsExpressSaver, H.UpsExpressSaver, U.UPS_EXPRESS_SAVER, H.UpsExpressSaver, U.Gls, H.Gls, U.GLS, H.Gls, U.Brt, H.Brt, U.BRT, H.Brt, U.Trunkrs, H.Trunkrs, U.TRUNKRS, H.Trunkrs, U.InPost, H.InPost, U.INPOST, H.InPost, U.PosteItaliane, H.PosteItaliane, U.POSTE_ITALIANE, H.PosteItaliane, U.Spring, H.Spring, U.SPRING, H.Spring, U.ViaTim, H.ViaTim, U.VIA_TIM, H.ViaTim, U.DhlFreight, H.DhlFreight, U.DHL_FREIGHT, H.DhlFreight, H.PostNl, H.Bpost, H.CheapCargo, H.Dpd, H.Instabox, H.Dhl, H.Bol, H.Ups, H.DhlForYou, H.DhlParcelConnect, H.DhlEuroPlus, H.UpsStandard, H.UpsExpressSaver, H.Gls, H.Brt, H.Trunkrs, H.InPost, H.PosteItaliane, H.Spring, H.ViaTim, H.DhlFreight;
var W = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
W.Austria, W.Belgium, W.Bulgaria, W.Croatia, W.Cyprus, W.CzechRepublic, W.Denmark, W.Estonia, W.Finland, W.France, W.Germany, W.Greece, W.Hungary, W.Ireland, W.Italy, W.Latvia, W.Lithuania, W.Luxembourg, W.Malta, W.Netherlands, W.Poland, W.Portugal, W.Romania, W.Slovakia, W.Slovenia, W.Spain, W.Sweden, Object.values(W), W.Angola, W.AntiguaAndBarbuda, W.Aruba, W.Bahamas, W.Belize, W.Benin, W.Bermuda, W.BonaireSintEustatiusAndSaba, W.Botswana, W.BurkinaFaso, W.Burundi, W.Cameroon, W.CanaryIslands, W.CentralAfricanRepublic, W.Comoros, W.CongoBrazzaville, W.CongoKinshasa, W.CoteDIvoire, W.Curacao, W.Djibouti, W.Dominica, W.DutchAntilles, W.EquatorialGuinea, W.Eritrea, W.Fiji, W.Gabon, W.Gambia, W.Ghana, W.Grenada, W.Guyana, W.HongKong, W.Kiribati, W.KoreaPeoplesDemocraticRepublic, W.Macao, W.Malawi, W.Mali, W.Mauritania, W.Nauru, W.Qatar, W.Rwanda, W.SaintKittsAndNevis, W.SaoTomeAndPrincipe, W.Seychelles, W.SierraLeone, W.SintMaarten, W.Suriname, W.SyrianArabRepublic, W.TimorLeste, W.Togo, W.Tonga, W.Tuvalu, W.Uganda, W.UnitedArabEmirates, W.Vanuatu, W.Yemen, W.Zimbabwe, W.Austria, W.Belgium, W.Bulgaria, W.Croatia, W.CzechRepublic, W.Estonia, W.Finland, W.France, W.Germany, W.Greece, W.Hungary, W.Ireland, W.Italy, W.Latvia, W.Lithuania, W.Luxembourg, W.Malta, W.Netherlands, W.Portugal, W.Romania, W.Slovakia, W.Slovenia, W.Spain, W.UnitedKingdom, W.Denmark, W.Germany, W.Sweden;
var G = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, K = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, q = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
G.EarlyMorning, K.EarlyMorning, G.Morning, K.Morning, G.Standard, K.Standard, G.Evening, K.Evening, G.Pickup, K.Pickup, G.PickupExpress, K.PickupExpress, G.SameDayDelivery, K.SameDayDelivery, G.Express, K.Express, K.EarlyMorning, G.EarlyMorning, K.Morning, G.Morning, K.Standard, G.Standard, K.Evening, G.Evening, K.Pickup, G.Pickup, K.PickupExpress, G.PickupExpress, K.SameDayDelivery, G.SameDayDelivery, K.Express, G.Express, G.EarlyMorning, q.EarlyMorning, G.Morning, q.Morning, G.Standard, q.Standard, G.Evening, q.Evening, G.Pickup, q.Pickup, G.PickupExpress, q.PickupExpress, G.SameDayDelivery, q.SameDayDelivery, G.Express, q.Express, q.EarlyMorning, K.EarlyMorning, q.Morning, K.Morning, q.Standard, K.Standard, q.Evening, K.Evening, q.Pickup, K.Pickup, q.PickupExpress, K.PickupExpress, q.SameDayDelivery, K.SameDayDelivery, q.Express, K.Express, G.EarlyMorning, G.Morning, G.Standard, G.Evening, G.Pickup, G.PickupExpress, G.SameDayDelivery, G.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var $s = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, ec = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
ec.Sunday, $s.Sunday, ec.Monday, $s.Monday, ec.Tuesday, $s.Tuesday, ec.Wednesday, $s.Wednesday, ec.Thursday, $s.Thursday, ec.Friday, $s.Friday, ec.Saturday, $s.Saturday, $s.Sunday, ec.Sunday, $s.Monday, ec.Monday, $s.Tuesday, ec.Tuesday, $s.Wednesday, ec.Wednesday, $s.Thursday, ec.Thursday, $s.Friday, ec.Friday, $s.Saturday, ec.Saturday;
var tc = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
tc.Bytes, tc.Kilobytes, tc.Megabytes, tc.Gigabytes, tc.Terabytes;
var nc = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, rc = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
nc.Bol, rc.Bol, nc.Exact, rc.Exact, nc.Amazon, rc.Amazon, nc.Wix, rc.Wix, nc.ExactDe, rc.ExactDe, nc.Etsy, rc.Etsy, rc.Bol, nc.Bol, rc.Exact, nc.Exact, rc.Amazon, nc.Amazon, rc.Wix, nc.Wix, rc.ExactDe, nc.ExactDe, rc.Etsy, nc.Etsy;
var J = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, Y = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
J.Unpaid, Y.Unpaid, J.Due, Y.Due, J.DuePrepayment, Y.DuePrepayment, J.Reminder1, Y.Reminder1, J.Reminder2, Y.Reminder2, J.Dun, Y.Dun, J.Collection, Y.Collection, J.Instalments, Y.Instalments, J.PaymentArrangement, Y.PaymentArrangement, J.Dispute, Y.Dispute, J.LegalProcedure, Y.LegalProcedure, J.Insolvency, Y.Insolvency, J.WriteOff, Y.WriteOff, J.Pending, Y.Pending, J.Cancelled, Y.Cancelled, J.Paid, Y.Paid, J.PaidOnline, Y.PaidOnline, J.PaidAutomatic, Y.PaidAutomatic, J.PaidCredit, Y.PaidCredit, J.PaidZeroItems, Y.PaidZeroItems, J.InvoiceWith0InvoiceItemsPaidZeroBalance, Y.PaidZeroBalance, J.Due, J.Reminder1, J.Reminder2, J.Dun, J.Collection, J.Instalments, J.PaymentArrangement, J.Dispute, J.Paid, J.PaidOnline, J.PaidAutomatic, J.PaidCredit, J.PaidZeroItems;
var ic = {
	Gram: "gram",
	Kilogram: "kilogram"
}, ac = {
	Gram: "g",
	Kilogram: "kg"
}, oc = {
	[ac.Gram]: 1,
	[ac.Kilogram]: 1e3
}, sc = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
sc.Millimeter, sc.Centimeter, sc.Meter;
var cc = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, lc = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
lc.PendingConcept, lc.PendingRegistered, lc.EnRouteHandedToCarrier, lc.EnRouteSorting, lc.EnRouteDistribution, lc.EnRouteCustoms, lc.DeliveredReadyForPickup, lc.DeliveredAtRecipient, lc.DeliveredPackagePickedUp;
var X = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, uc = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
uc.Light, X.Light, uc.Start, X.Start, uc.Plus, X.Plus, uc.Premium, X.Premium, uc.Max, X.Max, X.Light, uc.Light, X.Start, uc.Start, X.Plus, uc.Plus, X.Premium, uc.Premium, X.Max, uc.Max;
var dc = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, fc = {
	Start: X.Start,
	Plus: X.Plus,
	Premium: X.Premium,
	Max: X.Max
};
dc.Start, fc.Start, dc.Plus, fc.Plus, dc.Premium, fc.Premium, dc.Max, fc.Max, fc.Start, dc.Start, fc.Plus, dc.Plus, fc.Premium, dc.Premium, fc.Max, dc.Max;
var pc = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, mc = {
	Start: X.Start,
	Plus: X.Plus,
	Premium: X.Premium,
	Max: X.Max
};
pc.Start, mc.Start, pc.Plus, mc.Plus, pc.Premium, mc.Premium, pc.Max, mc.Max, mc.Start, pc.Start, mc.Plus, pc.Plus, mc.Premium, pc.Premium, mc.Max, pc.Max;
var hc = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, gc = {
	Light: X.Light,
	Start: X.Start,
	Plus: X.Plus,
	Premium: X.Premium,
	Max: X.Max
};
hc.Light, gc.Light, hc.Start, gc.Start, hc.Plus, gc.Plus, hc.Premium, gc.Premium, hc.Max, gc.Max, gc.Light, hc.Light, gc.Start, hc.Start, gc.Plus, hc.Plus, gc.Premium, hc.Premium, gc.Max, hc.Max;
var _c = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, vc = {
	Start: X.Start,
	Plus: X.Plus,
	Premium: X.Premium,
	Max: X.Max
};
_c.Start, vc.Start, _c.Plus, vc.Plus, _c.Premium, vc.Premium, _c.Max, vc.Max, vc.Start, _c.Start, vc.Plus, _c.Plus, vc.Premium, _c.Premium, vc.Max, _c.Max;
var Z = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, yc = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, bc = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
Z.MyParcel, yc.MyParcel, Z.Flespakket, yc.Flespakket, Z.SendMyParcel, yc.SendMyParcel, Z.MyParcelIt, yc.MyParcelIt, Z.DeliverDutch, yc.DeliverDutch, Z.PostNlPlugin, yc.PostNlPlugin, Z.MyParcel, bc.MyParcelNl, Z.Flespakket, bc.MyParcelNl, Z.SendMyParcel, bc.MyParcelBe, Z.MyParcelIt, bc.MyParcelIt, Z.DeliverDutch, bc.DeliverDutch, Z.PostNlPlugin, bc.PostNlPlugin, bc.MyParcelNl, Z.MyParcel, bc.MyParcelBe, Z.SendMyParcel, bc.MyParcelIt, Z.MyParcelIt, bc.MyParcelNl, cc.HomeCountry, W.Netherlands, cc.Eu, cc.Row, W.Belgium, bc.MyParcelBe, cc.HomeCountry, W.Belgium, W.Netherlands, cc.Eu, cc.Row, bc.MyParcelBe, cc.HomeCountry, W.Belgium, cc.Eu, cc.Row, bc.MyParcelNl, cc.HomeCountry, W.Netherlands, cc.Eu, cc.Row, bc.MyParcelNl, cc.HomeCountry, W.Netherlands, W.Belgium, W.Luxembourg, H.Bpost, H.PostNl, H.DhlForYou, H.DhlParcelConnect, H.DhlEuroPlus, H.Ups, H.UpsStandard, H.UpsExpressSaver;
var Q = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, xc = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
Q.Package, xc.Package, Q.Mailbox, xc.Mailbox, Q.Letter, xc.Letter, Q.DigitalStamp, xc.DigitalStamp, Q.Pallet, xc.Pallet, Q.PackageSmall, xc.PackageSmall, Q.Envelope, xc.Envelope, xc.Package, Q.Package, xc.Mailbox, Q.Mailbox, xc.Letter, Q.Letter, xc.DigitalStamp, Q.DigitalStamp, xc.Pallet, Q.Pallet, xc.PackageSmall, Q.PackageSmall, xc.Envelope, Q.Envelope;
var Sc = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
Q.Package, Sc.PACKAGE, Q.Mailbox, Sc.MAILBOX, Q.Letter, Sc.UNFRANKED, Q.DigitalStamp, Sc.DIGITAL_STAMP, Q.Pallet, Sc.PALLET, Q.PackageSmall, Sc.SMALL_PACKAGE, Q.Envelope, Sc.ENVELOPE, Sc.PACKAGE, Q.Package, Sc.MAILBOX, Q.Mailbox, Sc.UNFRANKED, Q.Letter, Sc.DIGITAL_STAMP, Q.DigitalStamp, Sc.PALLET, Q.Pallet, Sc.SMALL_PACKAGE, Q.PackageSmall, Sc.ENVELOPE, Q.Envelope, Q.Package, Q.Mailbox, Q.Letter, Q.DigitalStamp, Q.Pallet, Q.PackageSmall, Q.Envelope;
var $ = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
$.PendingConcept, $.PendingRegistered, $.EnrouteHandedToCarrier, $.EnrouteSorting, $.EnrouteDistribution, $.DeliveredAtCustoms, $.DeliveredAtRecipient, $.DeliveredPackagePickedUp, $.DeliveredReturnShipmentPackagePickedUp, $.DeliveredAtAgreedLocation, $.PrintedLetter, $.PrintedDigitalStamp, $.InactiveConcept, $.InactiveRegistered, $.InactiveEnrouteHandedToCarrier, $.InactiveEnrouteSorting, $.InactiveEnrouteDistribution, $.InactiveEnrouteCustoms, $.InactiveDeliveredAtRecipient, $.InactiveDeliveredReadyForPickup, $.InactiveDeliveredPackagePickedUp;
var Cc = {
	MILLIMETER: "mm",
	CENTIMETER: "cm",
	DECIMETER: "dm",
	METER: "m",
	KILOMETER: "km"
}, wc = {
	GRAM: "g",
	KILOGRAM: "kg"
}, Tc = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var ee = "$isDayjsObject", te = function(e) {
			return e instanceof re || !(!e || !e[ee]);
		}, ne = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, x = function(e, t) {
			if (te(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new re(n);
		}, S = v;
		S.l = ne, S.i = te, S.w = function(e, t) {
			return x(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var re = function() {
			function g(e) {
				this.$L = ne(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[ee] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (S.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return S;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = x(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return x(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < x(e);
			}, _.$g = function(e, t, n) {
				return S.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!S.u(t) || t, u = S.p(e), p = function(e, t) {
					var i = S.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return S.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = S.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[S.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = S.p(u), h = function(e) {
					var t = x(p);
					return S.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return S.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = S.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return S.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return S.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return S.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return S.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return S.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return S.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return S.s(t.$s, 2, "0");
							case "SSS": return S.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = S.p(f), _ = x(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return S.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : S.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = ne(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return S.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), ie = re.prototype;
		return x.prototype = ie, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			ie[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), x.extend = function(e, t) {
			return e.$i ||= (e(t, re, x), !0), x;
		}, x.locale = ne, x.isDayjs = te, x.unix = function(e) {
			return x(1e3 * e);
		}, x.en = b[y], x.Ls = b, x.p = {}, x;
	}));
})), Ec = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Tc()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_nl = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (e === 1 || e === 8 || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), Dc = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Tc()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_it = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "it",
			weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
			weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
			weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
			months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
			weekStart: 1,
			monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "tra %s",
				past: "%s fa",
				s: "qualche secondo",
				m: "un minuto",
				mm: "%d minuti",
				h: "un' ora",
				hh: "%d ore",
				d: "un giorno",
				dd: "%d giorni",
				M: "un mese",
				MM: "%d mesi",
				y: "un anno",
				yy: "%d anni"
			},
			ordinal: function(e) {
				return e + "º";
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), Oc = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Tc()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_fr = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (e === 1 ? "er" : "");
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), kc = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_calendar = r();
	})(e, (function() {
		return function(e, t, n) {
			var r = "h:mm A", i = {
				lastDay: "[Yesterday at] " + r,
				sameDay: "[Today at] " + r,
				nextDay: "[Tomorrow at] " + r,
				nextWeek: "dddd [at] " + r,
				lastWeek: "[Last] dddd [at] " + r,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var r = t || this.$locale().calendar || i, a = n(e || void 0).startOf("d"), o = this.diff(a, "d", !0), s = "sameElse", c = o < -6 ? s : o < -1 ? "lastWeek" : o < 0 ? "lastDay" : o < 1 ? "sameDay" : o < 2 ? "nextDay" : o < 7 ? "nextWeek" : s, l = r[c] || i[c];
				return typeof l == "function" ? l.call(this, n()) : this.format(l);
			};
		};
	}));
})), Ac = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, s = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, c = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], l = function(e) {
			var t = a[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = a.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, s("seconds")],
			ss: [r, s("seconds")],
			m: [r, s("minutes")],
			mm: [r, s("minutes")],
			H: [r, s("hours")],
			h: [r, s("hours")],
			HH: [r, s("hours")],
			hh: [r, s("hours")],
			D: [r, s("day")],
			DD: [n, s("day")],
			Do: [i, function(e) {
				var t = a.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			M: [r, s("month")],
			MM: [n, s("month")],
			MMM: [i, function(e) {
				var t = l("months"), n = (l("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = l("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, s("year")],
			YY: [n, function(e) {
				this.year = o(e);
			}],
			YYYY: [/\d{4}/, s("year")],
			Z: c,
			ZZ: c
		};
		function f(n) {
			for (var r = n, i = a && a.formats, o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = o.length, c = 0; c < s; c += 1) {
				var l = o[c], u = d[l], f = u && u[0], p = u && u[1];
				o[c] = p ? {
					regex: f,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = o[n];
					if (typeof i == "string") r += i.length;
					else {
						var a = i.regex, c = i.parser, l = e.slice(r), u = a.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, o = e.args;
				this.$u = r;
				var s = o[1];
				if (typeof s == "string") {
					var c = !0 === o[2], l = !0 === o[3], u = c || l, d = o[2];
					l && (d = o[2]), a = this.$locale(), !c && d && (a = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var r = f(t)(e), i = r.year, a = r.month, o = r.day, s = r.hours, c = r.minutes, l = r.seconds, u = r.milliseconds, d = r.zone, p = /* @__PURE__ */ new Date(), m = o || (i || a ? 1 : p.getDate()), h = i || p.getFullYear(), g = 0;
							i && !a || (g = a > 0 ? a - 1 : p.getMonth());
							var _ = s || 0, v = c || 0, y = l || 0, b = u || 0;
							return d ? new Date(Date.UTC(h, g, m, _, v, y, b + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(h, g, m, _, v, y, b)) : new Date(h, g, m, _, v, y, b);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
				} else if (s instanceof Array) for (var p = s.length, m = 1; m <= p; m += 1) {
					o[1] = s[m - 1];
					var h = n.apply(this, o);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === p && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), jc = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isBetween = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isBetween = function(e, t, r, i) {
				var a = n(e), o = n(t), s = (i ||= "()")[0] === "(", c = i[1] === ")";
				return (s ? this.isAfter(a, r) : !this.isBefore(a, r)) && (c ? this.isBefore(o, r) : !this.isAfter(o, r)) || (s ? this.isBefore(a, r) : !this.isAfter(a, r)) && (c ? this.isAfter(o, r) : !this.isBefore(o, r));
			};
		};
	}));
})), Mc = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isLeapYear = r();
	})(e, (function() {
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
})), Nc = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isToday = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isToday = function() {
				var e = "YYYY-MM-DD", t = n();
				return this.format(e) === t.format(e);
			};
		};
	}));
})), Pc = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isYesterday = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isYesterday = function() {
				var e = "YYYY-MM-DD", t = n().subtract(1, "day");
				return this.format(e) === t.format(e);
			};
		};
	}));
})), Fc = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_timezone = r();
	})(e, (function() {
		var e = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, t = {};
		return function(n, r, i) {
			var a, o = function(e, n, r) {
				r === void 0 && (r = {});
				var i = new Date(e);
				return function(e, n) {
					n === void 0 && (n = {});
					var r = n.timeZoneName || "short", i = e + "|" + r, a = t[i];
					return a || (a = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: e,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: r
					}), t[i] = a), a;
				}(n, r).formatToParts(i);
			}, s = function(t, n) {
				for (var r = o(t, n), a = [], s = 0; s < r.length; s += 1) {
					var c = r[s], l = c.type, u = c.value, d = e[l];
					d >= 0 && (a[d] = parseInt(u, 10));
				}
				var f = a[3], p = f === 24 ? 0 : f, m = a[0] + "-" + a[1] + "-" + a[2] + " " + p + ":" + a[4] + ":" + a[5] + ":000", h = +t;
				return (i.utc(m).valueOf() - (h -= h % 1e3)) / 6e4;
			}, c = r.prototype;
			c.tz = function(e, t) {
				e === void 0 && (e = a);
				var n = this.utcOffset(), r = this.toDate(), o = r.toLocaleString("en-US", { timeZone: e }), s = Math.round((r - new Date(o)) / 1e3 / 60), c = i(o, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(r.getTimezoneOffset() / 15) - s, !0);
				if (t) {
					var l = c.utcOffset();
					c = c.add(n - l, "minute");
				}
				return c.$x.$timezone = e, c;
			}, c.offsetName = function(e) {
				var t = this.$x.$timezone || i.tz.guess(), n = o(this.valueOf(), t, { timeZoneName: e }).find((function(e) {
					return e.type.toLowerCase() === "timezonename";
				}));
				return n && n.value;
			};
			var l = c.startOf;
			c.startOf = function(e, t) {
				if (!this.$x || !this.$x.$timezone) return l.call(this, e, t);
				var n = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return l.call(n, e, t).tz(this.$x.$timezone, !0);
			}, i.tz = function(e, t, n) {
				var r = n && t, o = n || t || a, c = s(+i(), o);
				if (typeof e != "string") return i(e).tz(o);
				var l = function(e, t, n) {
					var r = e - 60 * t * 1e3, i = s(r, n);
					if (t === i) return [r, t];
					var a = s(r -= 60 * (i - t) * 1e3, n);
					return i === a ? [r, i] : [e - 60 * Math.min(i, a) * 1e3, Math.max(i, a)];
				}(i.utc(e, r).valueOf(), c, o), u = l[0], d = l[1], f = i(u).utcOffset(d);
				return f.$x.$timezone = o, f;
			}, i.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, i.tz.setDefault = function(e) {
				a = e;
			};
		};
	}));
})), Ic = /* @__PURE__ */ Xs(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r, s = this;
				if (i) return s.$offset = o, s.$u = r === 0, s;
				if (r !== 0) {
					var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c;
				} else s = this.utc();
				return s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
}));
Ec(), Dc(), Oc();
var Lc = /* @__PURE__ */ Qs(Tc(), 1), Rc = /* @__PURE__ */ Qs(kc(), 1), zc = /* @__PURE__ */ Qs(Ac(), 1), Bc = /* @__PURE__ */ Qs(jc(), 1), Vc = /* @__PURE__ */ Qs(Mc(), 1), Hc = /* @__PURE__ */ Qs(Nc(), 1), Uc = /* @__PURE__ */ Qs(Pc(), 1), Wc = /* @__PURE__ */ Qs(Fc(), 1), Gc = /* @__PURE__ */ Qs(Ic(), 1);
Lc.default.extend(zc.default), Lc.default.extend(Vc.default), Lc.default.extend(Rc.default), Lc.default.extend(Gc.default), Lc.default.extend(Bc.default), Lc.default.extend(Hc.default), Lc.default.extend(Uc.default), Lc.default.extend(Wc.default), Lc.default.locale("nl"), Lc.default.tz.setDefault("Europe/Amsterdam"), Lc.default;
var Kc = {
	[Cc.MILLIMETER]: "unit.millimeter.short",
	[Cc.CENTIMETER]: "unit.centimeter.short",
	[Cc.DECIMETER]: "unit.decimeter.short",
	[Cc.METER]: "unit.meter.short",
	[Cc.KILOMETER]: "unit.kilometer.short",
	[wc.GRAM]: "unit.gram.short",
	[wc.KILOGRAM]: "unit.kilogram.short"
}, qc = (e) => Kc[e], Jc = (e) => {
	switch (e) {
		case "g":
		case ac.Gram:
		case ic.Gram: return oc[ac.Gram];
		case ac.Kilogram:
		case ic.Kilogram: return oc[ac.Kilogram];
		default: throw Error(`Unknown weight unit: ${e}`);
	}
}, Yc = {
	[Cc.MILLIMETER]: 1,
	[Cc.CENTIMETER]: 10,
	[Cc.DECIMETER]: 100,
	[Cc.METER]: 1e3,
	[Cc.KILOMETER]: 1e6
}, Xc = ({ value: e, unit: t }, n) => {
	let r = Yc[t], i = Yc[n];
	return !r || !i ? e : e * r / i;
}, Zc = (e) => Object.hasOwn(Yc, e), Qc = ({ value: e, unit: t }) => Zc(t) ? Xc({
	value: e,
	unit: t
}, Cc.CENTIMETER) : void 0, $c = ({ value: e, unit: t }) => Zc(t) ? Xc({
	value: e,
	unit: t
}, Cc.METER) : void 0, el = ({ value: e, unit: t }) => Zc(t) ? Xc({
	value: e,
	unit: t
}, Cc.MILLIMETER) : void 0, tl = ({ value: e, unit: t }) => Zc(t) ? Xc({
	value: e,
	unit: t
}, Cc.KILOMETER) : void 0, nl = {
	[wc.GRAM]: 1,
	[wc.KILOGRAM]: 1e3
}, rl = ({ value: e, unit: t }, n) => {
	let r = nl[t], i = nl[n];
	return !r || !i ? e : e * r / i;
}, il = (e) => Object.hasOwn(nl, e), al = {
	convertLengthUnit: Xc,
	convertMassUnit: rl,
	getUnitTranslationKey: qc,
	getWeightFactor: Jc,
	isLengthUnit: Zc,
	isMassUnit: il,
	toCentimetres: Qc,
	toGrams: ({ value: e, unit: t }) => il(t) ? rl({
		value: e,
		unit: t
	}, wc.GRAM) : void 0,
	toKilograms: ({ value: e, unit: t }) => il(t) ? rl({
		value: e,
		unit: t
	}, wc.KILOGRAM) : void 0,
	toKilometres: tl,
	toMetres: $c,
	toMillimetres: el,
	transformMetersToKilometers: (e) => {
		let t = e / 1e3;
		return t % 1 == 0 ? t : parseFloat(t.toFixed(1));
	}
}, ol = (e, t) => {
	let n;
	switch (t) {
		case _s.Gram:
			n = e;
			break;
		default: n = al.getWeightFactor(t) * e;
	}
	return {
		value: n,
		unit: "g"
	};
}, sl = (e) => {
	switch (e.unit) {
		case "g": return e.value;
		case "kg": return e.value * al.getWeightFactor("kg");
		default: return e.value;
	}
}, cl = Object.values(yn).filter((e) => e !== yn.DISCOVERED), ll = (e) => e === yn.DISCOVERED || e === yn.IMPORT_REQUESTED, ul = Object.values(yn).filter((e) => !ll(e)), dl = (e) => e === yn.CANCELED, fl = (e) => e === yn.IMPORT_REQUESTED;
//#endregion
export { Ps as ADJUSTED_DELIVERY_TYPES, zs as ADJUSTED_PICKUP_TYPES, cn as AddPackagesSchema, Gn as AddressSchema, Zn as BillingDetailsSchema, mn as Carrier, fn as CarrierSchema, kn as CarrierToCreate, Yn as CarrierToCreateSchema, Qt as ContactBusinessSchema, Ft as ContactMultiEmailBusinessSchema, qn as ContactMultiEmailPrivateSchema, en as ContactMultiEmailSchema, Rt as ContactPrivateSchema, Lt as ContactSchema, Jt as CountryCodeSchema, On as CreateOrderFromShippablePackagesSchema, Nt as CustomerReferenceSchema, os as CustomsDeclarationPurpose, Dn as CustomsDeclarationResponseSchema, Kt as CustomsDeclarationSchema, qt as DeliveryOptionsSchema, Yt as DeliverySchema, C as DeliveryType, zt as DeliveryTypeSchema, Ht as DropOffSchema, Gt as ExternalReferenceEcommercePlatformSchema, Zt as ExternalReferenceSalesChannelSchema, $n as ExternalReferencesImportSchema, Pt as ExternalReferencesMyParcelShopSchema, nn as ExternalReferencesSalesChannelSchema, Vt as ExternalReferencesSchema, gn as GeoAreaCode, tn as GeoAreaCodeSchema, rn as LabelWithBarcodeSchema, Bt as LabelWithoutBarcodeSchema, Wt as LineExternalReferenceSchema, Rn as LineSchema, Ut as MoneySchema, on as NoteFromImportedSchema, an as NoteFromPrincipalSchema, sn as NoteSchema, Xt as OrderSchema, yn as OrderStatus, Mt as OrderStatusSchema, vn as PackageCommonSchema, Un as PackageRequestSchema, Pn as PackageResponseSchema, ss as PackageStatusGroup, Bn as PackageStatusSchema, In as PackageType, En as PackageTypeSchema, jn as PaymentStatus, dn as PaymentStatusSchema, Fn as PhysicalPropertiesSchema, Vn as PhysicalPropertiesWeightRequiredSchema, hn as PickupSchema, An as PreparePackagesForShipmentPackageSchema, Wn as PreparePackagesForShipmentSchema, _n as ProblemDetailsClientSchema, bn as ProblemDetailsInternalServerErrorSchema, Ln as ProblemDetailsInvalidRequestSyntaxSchema, Mn as ProblemDetailsSchema, wn as RegionCodeSchema, Cn as ShipmentDirection, Sn as ShipmentDirectionSchema, ln as ShipmentOptionsCommonSchema, Kn as ShipmentOptionsPackageSchema, Qn as ShipmentOptionsSchema, pn as ShipmentRequestSchema, Xn as ShipmentSchema, $t as ShippablePackageSchema, It as ShippingSchema, xn as SortDirection, Jn as SortDirectionSchema, ul as activeOrderStatuses, cl as allStatusesExceptDiscovered, Fs as deliveryTypeV1ToV2, Is as deliveryTypeV2ToV1, nr as events, _t as getOrders, it as getPackingSlips, pt as getPicklist, Bs as isAdjustedDeliveryType, Vs as isAdjustedPickupType, cs as isBusinessContact, Hn as isCreateMulticolloShippablePackage, Nn as isCreateShippablePackage, ll as isDiscoverableOrderStatus, us as isLabelWithBarcode, ds as isLabelWithoutBarcode, dl as isOrderCanceled, fl as isOrderImportRequested, ls as isPrivateContact, zn as isShipPackagesAsMulticollo, Tn as isShipPackagesRequest, sl as mapServiceWeightToGrams, ol as mapWeightToService, as as matchOrderEvent, Us as moneyFromMicros, Hs as moneyToMicros, vt as orderApiAcceptanceUrl, at as orderApiUrl, Je as postAddNote, Ne as postAddPackages, st as postAssignToUser, ht as postCancel, Le as postCreateFromShippablePackages, et as postEditNote, bt as postEvaluateRules, ze as postImport, He as postPreparePackagesForShipment, lt as postRemoveNotes, nt as postUnassignFromUser, Ke as postUnpreparePackagesForShipment, Ls as toDeliveryTypeV1, Rs as toDeliveryTypeV2, er as useOrderService, We as zAddPackages, je as zAddress, St as zBillingDetails, Ot as zCarrier, Fe as zCarrierToCreate, Et as zContact, he as zContactBusiness, o as zContactMultiEmail, wt as zContactMultiEmailBusiness, _e as zContactMultiEmailPrivate, u as zContactPrivate, c as zCountryCode, se as zCreateOrderFromShippablePackages, Qe as zCustomerReference, n as zCustomsDeclaration, Xe as zCustomsDeclarationResponse, re as zDelivery, ae as zDeliveryOptions, le as zDeliveryType, f as zDropOff, v as zExternalReferenceEcommercePlatform, x as zExternalReferenceSalesChannel, pe as zExternalReferences, At as zExternalReferencesImport, i as zExternalReferencesMyParcelShop, xe as zExternalReferencesSalesChannel, g as zGeoAreaCode, ye as zGetOrdersData, Ce as zGetOrdersResponse, m as zGetPackingSlipsData, te as zGetPackingSlipsResponse, dt as zGetPicklistData, b as zGetPicklistResponse, De as zLabelWithBarcode, Te as zLabelWithoutBarcode, ke as zLine, de as zLineExternalReference, e as zMoney, Ve as zNote, yt as zNoteFromImported, ot as zNoteFromPrincipal, mt as zOrder, Ye as zOrderStatus, Pe as zPackageCommon, ct as zPackageRequest, gt as zPackageResponse, Re as zPackageStatus, tt as zPackageType, xt as zPaymentStatus, Be as zPhysicalProperties, Ue as zPhysicalPropertiesWeightRequired, ut as zPickup, rt as zPostAddNoteData, qe as zPostAddNoteResponse, Ge as zPostAddPackagesData, Me as zPostAddPackagesResponse, Ct as zPostAssignToUserData, kt as zPostAssignToUserResponse, Ie as zPostCancelData, Dt as zPostCancelResponse, ge as zPostCreateFromShippablePackagesData, s as zPostCreateFromShippablePackagesResponse, Tt as zPostEditNoteData, ve as zPostEditNoteResponse, d as zPostEvaluateRulesData, l as zPostEvaluateRulesResponse, ce as zPostImportData, $e as zPostImportResponse, r as zPostPreparePackagesForShipmentData, Ze as zPostPreparePackagesForShipmentResponse, ie as zPostRemoveNotesData, oe as zPostRemoveNotesResponse, ue as zPostUnassignFromUserData, p as zPostUnassignFromUserResponse, y as zPostUnpreparePackagesForShipmentData, S as zPostUnpreparePackagesForShipmentResponse, me as zPreparePackagesForShipment, jt as zPreparePackagesForShipmentPackage, a as zProblemDetails, Se as zProblemDetailsClient, _ as zProblemDetailsInternalServerError, be as zProblemDetailsInvalidRequestSyntax, we as zRegionCode, h as zShipment, ne as zShipmentDirection, ft as zShipmentOptions, ee as zShipmentOptionsCommon, Oe as zShipmentOptionsPackage, Ee as zShipmentRequest, Ae as zShippablePackage, fe as zShipping, t as zSortDirection };
